<template>

  <div class="head">
    <headr :menuIndex=2></headr>

    <div id="pc">

      <div class="menu">
        <div :style="menuIndex==0?menuYes:menuNo" @click="onclick(0)"><span>常见问题</span></div>
        <div :style="menuIndex==1?menuYes:menuNo" @click="onclick(1)"><span>使用教程</span></div>
        <div :style="menuIndex==2?menuYes:menuNo" @click="onclick(2)"><span>用户协议</span></div>
        <div :style="menuIndex==3?menuYes:menuNo" @click="onclick(3)"><span>隐私政策</span></div>
        <div :style="menuIndex==4?menuYes:menuNo" @click="onclick(4)"><span>会员协议</span></div>

      </div>

      <div class="pc-menu0" v-show="menuIndex==0">

        <div>
          <p style="font-size: 16px;color: #333333;">海鸥是什么？</p>
          <p>海鸥是一款安全稳定的强隐私陌生人社交聊天软件，可以随时随地收发信息，支持与好友音视频通话、一对一单聊，多人群聊，具有保护用户隐私安全的特色功能（截屏提醒、账号销毁等特色功能）。
            海鸥致力于用户社交信息安全加密，让用户真正体验到私密空间社交，不获取任何与软件使用无关的用户个人信息，不对任何聊天记录收集私密存储。注册体验即生成私钥，开启安全加密通信，防破解，防篡改，防窃听，防监控，为你解决通信风险，让您的聊天更加安全稳定。
          </p>
        </div>

        <div>
          <p style="font-size: 16px;color: #333333;">怎么添加好友？</p>
          <p> 一、搜索添加</p>
          <p>在聊天界面，点击右上角【+】的图标，选择【加好友/群】，通过搜索海鸥版号、昵称、手机号、标签添加好友。</p>
          <p>二、扫码添加</p>
          <p>在聊天界面，点击右上角【+】的图标，选择【扫一扫】，扫描对方的二维码名片即可添加，也可以将自己的二维码名片通过短信、微信、QQ分享出去，让好友扫码添加你。</p>
          <!-- <p>三、附近人添加</p>
          <p>在发现界面【附近人】列表可以对感兴趣的陌生人发消息，或请求添加为好友。</p> -->
        </div>

        <div>
          <p style="font-size: 16px;color: #333333;">如何登录海鸥的PC版？</p>
          <p>一、登录海鸥PC版</p>
          <p> 使用浏览器访问https://www.haiouchat.com/，首页会出现windows下载，下载安装在电脑上后，用手机上的海鸥APP扫描该二维码，在弹出的页面中点击【登录】，即可在windows端使用海鸥。
            若扫描二维码无反应，先在海鸥APP的【聊天】界面顶部查看是否有pc端已登录提示，如果有先点击【退出pc端】，然后刷新网页上的二维码，再次扫描。 若还是不能登录，先检查一下网络连接是否正常，电脑时间是否为当地正常时间，如果均没有问题，按F5刷新再试试。
          </p>
          <p>二、退出海鸥PC版</p>
          <p>点击海鸥PC版左下角的【退出】按钮，在弹出的操作窗口中点击【确定】退出。也可以点击海鸥APP上【聊天】界面顶部的windows登录提示，进入登录信息页，点击【退出windows端】。</p>
        </div>

        <div>
          <p style="font-size: 16px;color: #333333;">忘记密码怎么办？</p>
          <p>海鸥版上的所有密码都是经过加密处理的，且未进行私密储存，一旦密码忘记，不能找回，只能重置。</p>
          <p>一、未登录状态</p>
          <p>
            在账号密码登录界面，点击密码输入框下的【忘记密码】选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入手机号获取验证码，重新两次设置新密码即可；第二种：【密保验证】先输入您的账号，再正确回答您设置的密保答案，重新两次设置新密码即可。
          </p>
          <p>二、已登录状态</p>
          <p>
            在【我的-设置-账号设置-登录密码】进入密码设置界面，点击【忘记旧密码】，选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入正确验证码后即可设置新的密码；第二种：【密保验证】正确回答您设置的密保答案，重新两次设置新密码即可。
          </p>
        </div>

        <div>
          <p style="font-size: 16px;color: #333333;">如何防范网络诈骗？</p>
          <p>1、看到“兼职、刷单、刷分、贷款、彩票、代理、返现、中奖、福利、兑换、手续费、保证金”等字眼时，一定要提高警惕。
            2、不熟悉的人发的链接不要轻易点开，不熟悉的人发的二维码不要轻易扫描；
            3、不要将自己的社交账号信息、购物支付账号信息、银行账户信息、付款码、收到的验证码，发送给不熟悉的人。
            4、要求先转账、先付款、先充值、先交手续费、先垫付本金再提供相应服务的，一定要提高警惕。
            5、声称某公司、某平台内部工作人员的，绝对不要轻信，请先联系其官方人员确认。
            6、自称是好友、亲人、领导等要求借款或缴纳钱款的，最好当面与其本人确认，不要贸然转账汇款。
            7、声称某网店、公司或网站客服，说误操作、订单有问题、账号被冻结的，绝对不要理会。
            8、声称公、检、法机构人员要求缴纳欠款，绝对不要付款，请先核实确认。
            9、不熟悉的人要求添加其他联系方式，到其他平台去聊天时，请慎重考虑。
            10、以交友的名义初步建立感情，然后以缺钱等名义让为其汇款的，绝对不要汇款。</p>
        </div>

        <div>
          <p style="font-size: 16px;color: #333333;">什么是海鸥密信？</p>
          <p>海鸥密信是海鸥系统中的电子邮件特色功能，支持全自动用数字证书加密每一封邮件和自动为每封发出的邮件盖上时间戳。海鸥版密信采用S/MIME国际标准加密电子邮件内容，S/MIME
            基于非对称加密，以保护您的电子邮件免受不必要的访问和篡改攻击。自动配置签名证书和加密证书。您可以放心地发送机密信息，可以放心地把所有机密信息和文件信息都加密发送到您的好友电子邮箱中，海鸥版全程加密发送保障机密信息不被窃取。
          </p>
        </div>

        <div>
          <p style="font-size: 16px;color: #333333;">删除聊天记录后还能找回吗？</p>
          <p>海鸥采用的是安全加密技术聊天，用户的聊天记录只会保存在用户的手机设备上，海鸥版平台不会进行聊天记录储存，用户一旦撤回或删除后，就将无法恢复找回，请谨慎操作。</p>
        </div>

        <div>
          <p style="font-size: 16px;color: #333333;">如何举报？</p>
          <p>在好友的资料详情页或群的详情页，点击右上角的三个小点【...】，就可以看到【举报/投诉】的入口，上传相关举报资料进行举报，我们收到信息后会尽快核实处理</p>
        </div>

      </div>

      <div class="pc-menu1" v-show="menuIndex==1">
        <div>
          <div :style="pcMenu1Index==0?pcMenu1Yes:pcMenu1YesNo" @click="onclickPcMenu1(0)"><img :src="pcMenu1Index==0?require('@/img/pc/Frame 1010104515@2x.png'):require('@/img/pc/Frame 1010104514@2x.png')" alt=""><span>常见问题</span></div>
          <div :style="pcMenu1Index==1?pcMenu1Yes:pcMenu1YesNo" @click="onclickPcMenu1(1)"><img :src="pcMenu1Index==1?require('@/img/pc/Frame@2x(1).png'):require('@/img/pc/Frame@2x.png')" alt=""><span>关于账号</span></div>
          <div :style="pcMenu1Index==2?pcMenu1Yes:pcMenu1YesNo" @click="onclickPcMenu1(2)"><img :src="pcMenu1Index==2?require('@/img/pc/Frame@2x(7).png'):require('@/img/pc/Frame@2x(6).png')" alt=""><span>关于好友</span></div>
          <div :style="pcMenu1Index==3?pcMenu1Yes:pcMenu1YesNo" @click="onclickPcMenu1(3)"><img :src="pcMenu1Index==3?require('@/img/pc/Frame@2x(5).png'):require('@/img/pc/Frame@2x(4).png')" alt=""><span>关于群聊</span></div>
          <div :style="pcMenu1Index==4?pcMenu1Yes:pcMenu1YesNo" @click="onclickPcMenu1(4)"><img :src="pcMenu1Index==4?require('@/img/pc/Frame@2x(3).png'):require('@/img/pc/Frame@2x(2).png')" alt=""><span>关于聊天</span></div>
          <div :style="pcMenu1Index==5?pcMenu1Yes:pcMenu1YesNo" @click="onclickPcMenu1(5)"><img :src="pcMenu1Index==5?require('@/img/pc/tongzhi@2x(1).png'):require('@/img/pc/tongzhi@2x.png')" alt=""><span>关于通知</span></div>
          <div :style="pcMenu1Index==6?pcMenu1Yes:pcMenu1YesNo" @click="onclickPcMenu1(6)"><img :src="pcMenu1Index==6?require('@/img/pc/shangcheng@2x(1).png'):require('@/img/pc/shangcheng@2x.png')" alt=""><span>关于商城</span></div>
          <div :style="pcMenu1Index==7?pcMenu1Yes:pcMenu1YesNo" @click="onclickPcMenu1(7)"><img :src="pcMenu1Index==7?require('@/img/pc/Frame@2x(9).png'):require('@/img/pc/Frame@2x(8).png')" alt=""><span>一键清理</span></div>
          <div :style="pcMenu1Index==8?pcMenu1Yes:pcMenu1YesNo" @click="onclickPcMenu1(8)"><img :src="pcMenu1Index==8?require('@/img/pc/qita@2x(1).png'):require('@/img/pc/qita@2x.png')" alt=""><span>关于其他</span></div>

        </div>
        <div class="pc-menu1-0" v-show="pcMenu1Index==0">
          <div class="pcMenu1One" v-show="pcMenu10==-1">
            <div><span>常见问题</span></div>
            <div>
              <p @click="pcMenu10=1">1. 海鸥会员怎么购买？</p>
              <p @click="pcMenu10=2">2. 海鸥成长值说明</p>
              <p @click="pcMenu10=3">3. 忘记密码怎么办？</p>
              <p @click="pcMenu10=4">4. 聊天记录删除后还能找回吗？</p>
              <p @click="pcMenu10=5">5. 怎么添加好友/群聊？</p>
              <p @click="pcMenu10=6">6. 鸥币充值常见问题？</p>
              <p @click="pcMenu10=7">7. 如何防范网络诈骗？</p>
              <p @click="pcMenu10=8">8. 如何会员等级提升？</p>
              <p @click="pcMenu10=9">9. 群管家使用规则？</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==1">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">海鸥会员购买</span></div>
            <div>
              <p>如何使用微信/支付宝购买会员？</p>
              <p>（1）安卓手机</p>
              <p>通过【会员中心】>>选择【开通VIP/SVIP】>>选择【微信支付】或【支付宝支付】>>【下一步】按照步骤进行支付即可。</p>
              <p>（2）苹果手机</p>
              <p>暂不支持微信/支付宝购买，敬请期待。</p>
              <p>如何使用鸥币购买会员？</p>
              <p>（1）安卓手机</p>
              <p>安卓端暂不支持使用鸥币购买。</p>
              <p>（2）苹果手机</p>
              <p>鸥币购买会员目前仅苹果端支持购买会员券，通过【海鸥商城】>>选择【购买会员券】>>选择【鸥币支付】按照步骤进行支付即可。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==2">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">海鸥成长值说明</span></div>
            <div>
              <p>海鸥等级成长值说明</p>
              <p>用来评定用户会员等级的值称为成长值；用户可通过消费平台商品（除鸥币支付订单）获取成长值，从而提升尊贵会员等级。
              </p>
              <p>
                成长值换算比例：每消耗满10元=1成长值，未达到满10不计入成长值换算。所有消费需已支付并完成后可获得相应成长值，请勿违规刷成长值（包括但不限于虚假交易、恶意获取等
              </p>
              <p>行为）若发现存在违规行为，我们将取消您获取成长值的资格。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==3">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">忘记密码怎么办？</span></div>
            <div>
              <p>海鸥上的所有密码都是经过加密处理的，且未进行私密储存，一旦密码忘记，不能找回，只能重置。 </p>
              <p>未登录状态</p>
              <p>
                在账号密码登录界面，点击密码输入框下的【忘记密码】选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入手机号获取验证码，重新两次设置新密码即可；第二种：【密保验证】先输入您的账号，再正确回答您设置的密保答案，重新两次设置新密码即可。
              </p>
              <p>已登录状态</p>
              <p>
                在【我的-设置-账号设置-登录密码】进入密码设置界面，点击【忘记旧密码】，选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入正确验证码后即可设置新的密码；第二种：【密保验证】正确回答您设置的密保答案，重新两次设置新密码即可。
              </p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==4">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">聊天记录删除后还能找回吗？</span></div>
            <div>
              <p>海鸥APP采用的是安全加密技术聊天，用户的聊天记录只会保存在用户的手机设备上，海鸥平台不会进行聊天记录储存，用户一旦撤回或删除后，就将无法恢复找回，请谨慎操作。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==5">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">怎么添加好友/群聊？</span></div>
            <div>
              <p>1. 搜索添加</p>
              <p>在聊天界面，点击右上角【+】的图标，选择【加好友/群】，通过搜索海鸥号、昵称、手机号、标签添加好友。</p>
              <p>2. 扫码添加</p>
              <p>在聊天界面，点击右上角【+】的图标，选择【扫一扫】，扫描对方的二维码名片即可添加，也可以将自己的二维码名片通过短信、微信、QQ分享出去，让好友扫码添加你。
              </p>
              <!-- <p>3. 附近人添加</p>
              <p>在发现界面【附近人】列表可以对感兴趣的陌生人发消息，或请求添加为好友。</p> -->
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==6">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">鸥币充值常见问题？</span></div>
            <div>
              <p>如何使用微信/支付宝购买会员？</p>
              <p>（1）安卓手机</p>
              <p>通过【会员中心】>>选择【开通VIP/SVIP】>>选择【微信支付】或【支付宝支付】>>【下一步】按照步骤进行支付即可。</p>
              <p>（2）苹果手机</p>
              <p>暂不支持微信/支付宝购买，敬请期待。</p>
              <p>如何使用鸥币购买会员？</p>
              <p>（1）安卓手机</p>
              <p>安卓端暂不支持使用鸥币购买。</p>
              <p>（2）苹果手机</p>
              <p>鸥币购买会员目前仅苹果端支持购买会员券，通过【海鸥商城】>>选择【购买会员券】>>选择【鸥币支付】按照步骤进行支付即可。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==7">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">如何防范网络诈骗？</span></div>
            <div>
              <p>
                海鸥APP是一款安全加密的聊天软件，与微信、钉钉一样，主要为用户提供聊天交友的相关功能。作为独立的聊天软件，海鸥版H版APP不归属于任何平台，若遇到冒充海鸥版客或假借海鸥版H版APP名义联系您的情况，请先联系海鸥版的唯一官方客服确认。<br>
                网络骗术层出不穷，请警惕任何利用聊天工具进行的欺诈行为，如娱乐平台充值、网络 贷款、兼职刷单、套现返现、网络彩票、色情服务等。若遇到此类情况，建议第一时间
                保存好相关资料，向相关平台或机构举报，并报警求助。<br>
                <br>
                海鸥防骗指南<br>
                （1）看到“兼职、刷单、刷分、贷款、彩票、代理、返现、中奖、福利、兑换、手续费、保证金”字眼时，一定要提高警惕。<br>
                （2）不熟悉的人发的链接不要轻易点开，不熟悉的人发的二维码不要轻易扫描；<br>
                （3）不要将自己的社交账号信息、购物支付账号信息、银行账户信息、付款码、收到的验证码，发送给不熟悉的人。<br>
                （4）要求先转账、先付款、先充值、先交手续费、先垫付本金再提供相应服务的，一定要提高警惕。<br>
                （5）声称某公司、某平台内部工作人员的，绝对不要轻信，请先联系其官方人员确认。<br>
                （6）自称是好友、亲人、领导等要求借款或缴纳钱款的，最好当面与其本人确认，不要贸然转账汇款。<br>
                （7）声称某网店、公司或网站客服，说误操作、订单有问题、账号被冻结的，绝对不要理会。<br>
                （8）声称公、检、法机构人员要求缴纳欠款，绝对不要付款，请先核实确认。<br>
                （9）不熟悉的人要求添加其他联系方式，到其他平台去聊天时，请慎重考虑。<br>
                （10）以交友的名义初步建立感情，然后以缺钱等名义让为其汇款的，绝对不要汇款。
              </p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==8">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">如何会员等级提升？</span></div>
            <div>
              <p>1. 等级有效期<br>
                海鸥会员等级在用户始终为会员身份期间，会一直保留尊贵等级身份，若用户会员身份到期后，或因用户其他原因导致会员到期后始终未续费，会员等级将不再降级，成长值也不会过期。<br><br>

                2. 升级规则<br>
                用户在会员等级有效期内产生消费（除鸥币支付订单）都会获得相应等级成长值，达到升级门槛值，新等级立即生效。用户如果已登顶，将继续累积成长值，成长值可赠送好友，会扣除自己相应成长值；封顶是20000成长值，如他有21000成长值
                其中20500成长值是别人赠送的，另外500成长值是自己消费所得的成长值；则只有500成长值是可赠送给他人。<br><br>

                3. 等级权益<br>
                不同的会员等级可享受该等级专属权益，我们将根据运营等实际情况不定期调整或更新，具体权益届时以页面展示为准。</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==9">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">群管家使用规则？</span></div>
            <div>
              <p>功能说明<br>
                1）使用群管家券成功后，创建群将获得群管家使用入口，群主或管理员可以在群聊详情开启群管家并设置相关管理权限。已创建的群组可尊享【成员进群欢迎语】设置、【成员发言管理】设置、【成员自助问答】设置等便携群管服务。<br>
                2）本群管家券可转赠好友/群聊<br>
                3）若已使用群管家券，请提前及时续费，若到期后，该群聊将失去群管家功能及设置数据<br><br>

                获取方式<br>
                1）通过在【海鸥商城】-【购买群管家券】可以获取<br>
                2）通过好友赠送给自己<br><br>

                使用方式<br>
                1）【海鸥商城】-【群管家券】可以使用已拥有的群管家券。<br>
                2）群管家券可转赠他人，在【海鸥商城】-【群管家券】卡券详情里，点击【赠送好友】；也可以在单聊群聊聊天界面点击【+】-【卡券】中赠送</p>

            </div>

          </div>

        </div>

        <div class="pc-menu1-1" v-show="pcMenu1Index==1">
          <div class="pcMenu1One" v-show="gyzhIndex==-1">
            <div><span>关于账号</span></div>
            <div>
              <p @click="gyzhIndex=1">1. 注册账号</p>
              <p @click="gyzhIndex=2">2. 登录密码设置/修改</p>
              <p @click="gyzhIndex=3">3. 应用锁设置</p>
              <p @click="gyzhIndex=4">4. 密保问题</p>
              <p @click="gyzhIndex=5">5. 个人设置</p>
              <p @click="gyzhIndex=6">6. 更换手机号</p>
              <p @click="gyzhIndex=7">7. 等级和经验值</p>
              <p @click="gyzhIndex=8">8. 登录/退出</p>
              <p @click="gyzhIndex=9">9. 账号注销</p>
              <p @click="gyzhIndex=10">10. 账号申诉</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==1">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">注册账号</span></div>
            <div>
              <p>在应用市场搜索“海鸥”或“海鸥m”，找到海鸥APP，进行下载安装，也可以直接去海鸥官网<br>
                https://www.haiouchat.com去下载最新版本进行安装<br><br>

                在注册界面，输入正确的手机号，点击获取验证码，勾选同意《用户协议》和《隐私政策》，你将会得到一个海鸥ID号，表示注册成功。妥善保存好自己的ID，变异以后登录；也可以用注册的手机号验证码登录。若想使用其他ID号，可以到【海鸥商城-靓号专区】去购买。
              </p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==2">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">登录密码设置/修改</span></div>
            <div>
              <p>在登录页面，输入海鸥ID号和登录密码，就可以登录海鸥。<br><br>

                设置登录密码<br>
                登录密码在【我的-设置中心-账号安全-登录密码】中进行设置，密码至少8个字符，而且同时包含字母和数字。<br><br>

                修改登录密码<br>
                要修改登录密码，只需在登录密码设置页面输入正确的旧密码和要设置的新密码，点击【确定】即可。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==3">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">应用锁设置</span></div>
            <div>
              <p>应用锁类似于手机锁屏密码，开启后，则每次都需要通过解锁密码验证才能进入海鸥APP。<br><br>

                设置应用锁<br>
                应用锁在【我的-设置中心-账号安全-应用锁】中进行设置，输入两遍解锁密码后，可通过【锁屏时间】设置应用切换后进入密码锁定的时间。<br><br>

                修改应用锁密码<br>
                要修改应用锁密码，只需在应用锁密码设置页面点击【更改解锁密码】输入正确的旧密码和要设置的新密码。若忘记了原解锁密码可以点击【忘记应锁密码】按【确定】按钮，重新登录即可重新设置应用锁密码。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==4">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">密保问题</span></div>
            <div>
              <p>密保问题可以用来重置登录密码。<br><br>

                设置和修改密保问题<br>
                密保问题在【我的-设置中心-账号安全-密保问题】中进行设置，要修改密保问题需要验证原密保的答案，就可以重新设置。若忘记原来的密保问题和答案，可在密保设置页点击【忘记密保】，通过绑定的手机号来重新设置密保。<br><br>

                通过密保问题重置密码<br>
                重置登录密码。在修改密码时，点击【忘记旧密码】通过密保问题，重新设置登录密码。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==5">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">个人设置</span></div>
            <div>
              <p>在【我的】页面点击顶部的个人头像，进入个人信息页面，即可对你的头像、昵称、性别、生日、地区、个人标签、个性签名等进行设置，也可以复制自己的海鸥号，保存和分享自己的二维码名片。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==6">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">更换手机号</span></div>
            <div>
              <p>使用验证码直接修改手机号<br>
                修改手机号在【我的-设置中心-手机号码】中点击【更换绑定手机号】进行更改，需要填写完整的手机号，然后输入短信验证码进行验证换绑新的手机号。更换成功后，可使用新的手机号和验证码登录海鸥。<br><br>

                连续登录可直接修改手机号<br>
                修改手机号在【我的-设置中心-手机号码】中点击【我已经换号】进入换绑手机号满足的所需要的天数可获得 1 次换绑机会，每个ID号仅限 3 次换绑。直接输入新手机号和验证码即可换绑成功。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==7">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">等级和经验值</span></div>
            <div>
              <p>查看账号等级和经验值<br>
                通过【我的-海鸥等级】进入海鸥等级信息页面，可查看自己账号当前等级、当前经验值、成长速度；以及加入海鸥总天数等。<br><br>

                查看成长攻略（经验值获取）<br>
                想要提升账号等级，就需要不断积累获得经验值。在账号等级页面，点击右上角的【查看成长攻略】，进入海鸥成长体系，即可查看海鸥经验值获取方式，以及海鸥等级与所需经验值对照表。经验值不仅可用于海鸥账号等级的提升，还决定用户排行榜的排名。
              </p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==8">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">登录/退出</span></div>
            <div>
              <p>账号登录<br>
                海鸥有【手机号+验证码】、【海鸥号+密码】两种登录方式，在登录界面按钮下方有切换登录方式。<br>
                在【我的-设置中心-账号安全-登录设置】中，可以禁止用密码登录、禁止使用验证码登录、新设备需要验证。若禁用手机验证码登录，海鸥将收不触发对应的验证码发送，同样意味着不可再通过手机验证码来设置修改密码、密保。<br><br>

                账号退出<br>
                在【我的-设置中心-账号管理】中点击退出账号，在弹出的操作提示中点击【确定退出】<br><br>

                切换账号<br>
                在【我的-设置中心-账号管理】中点击添加账号后，可快捷切换登录其他海鸥账号。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==9">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">账号注销</span></div>
            <div>
              <p>在【我的-设置中心-账号安全-注销账号】中选择【立即销毁】，或选择一个自动注销时间，如果在这个时间里，一直未登录使用海鸥，账号就会自动注销。<br>
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==10">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">账号申诉</span></div>
            <div>
              <p>在【我的-设置中心-账号安全-注销账号】中选择【立即销毁】，或选择一个自动注销时间，如果在这个时间里，一直未登录使用海鸥，账号就会自动注销。<br> </p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-2" v-show="pcMenu1Index==2">
          <div class="pcMenu1One" v-show="gyhyIndex==-1">
            <div><span>关于好友</span></div>
            <div>
              <p @click="gyhyIndex=1">1. 添加好友</p>
              <p @click="gyhyIndex=2">2. 删除好友</p>
              <p @click="gyhyIndex=3">3. 拉黑好友</p>
              <!-- <p @click="gyhyIndex=4">4. 阅后即焚</p> -->
              <p @click="gyhyIndex=4">4. 截屏通知</p>
              <p @click="gyhyIndex=5">5. 推荐给好友</p>
              <p @click="gyhyIndex=6">6. 消息定时清理</p>
              <p @click="gyhyIndex=7">7. 为好友添加备注和分组</p>
              <p @click="gyhyIndex=8">8. 举报违规用户</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==1">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">添加好友</span></div>
            <div>
              <p>搜索添加<br>
                在【消息】或【通讯录】界面，点击右上角的【+】的图标，选择【加好友/群】，通过搜索海鸥号、昵称、手机号、标签添加好友。<br>
                也可以使用右边【扫一扫】图标，扫描对方的二维码名片添加好友，或将自己的二维码名片通过短信、微信、QQ等方式分享出去，让对方扫描添加你。<br><br>

                排行榜添加<br>
                在【发现-等级排行】页面，可对感兴趣的陌生人加好友。若对方接受你的好友申请，你们即可成为好友进行聊天。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==2">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">删除好友</span></div>
            <div>
              <p>在【通讯录】列表中点击好友头像，进入对方主页，点击右上角【···】进入资料设置页，点击【删除】。删除后对方不再出现在您的联系人列表中，你们再也不能进行聊天。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==3">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">拉黑好友</span></div>
            <div>
              <p>加入黑名单<br>
                在【通讯录】列表中点击好友头像，进入对方主页，点击右上角【···】进入资料设置页，点击【加入黑名单】。拉黑后对方不再出现在您的联系人列表中，你将不会收到对方的消息。<br><br>

                移出黑名单<br>
                在【我的-设置中心-隐私】中点击【黑名单】，点击想要移出的联系人，弹窗提示【移出黑名单】</p>
            </div>

          </div>

          <!-- <div class="pcMenu1Two" v-show="gyhyIndex==4">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">阅后即焚</span></div>
            <div>
              <p>单聊阅后即焚<br>
                在【通讯录】列表中点击好友头像，点【发送消息】进入对方聊天页面，点击右上角【···】进入聊天详情页，点击【阅后即焚】，然后设置对应的秒数，消息已读后将自动销毁。<br><br>

                群聊阅后即焚<br>
                在【通讯录】列表中点击群聊，进入群聊页面，点击右上角【···】进入群聊设置页，点击【阅后即焚】，然后设置对应的秒数，消息已读后将自动销毁。</p>
            </div>
          </div> -->

          <div class="pcMenu1Two" v-show="gyhyIndex==4">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">截屏通知</span></div>
            <div>
              <p>单聊截屏通知<br>
                在【通讯录】列表中点击好友头像，点【发送消息】进入对方聊天页面，点击右上角【···】进入聊天详情页，点击【截屏通知】，开启后截屏，双方均会收到通知。<br><br>

                群聊截屏通知（群主/管理员）<br>
                在【通讯录】列表中点击群聊，进入群聊页面，点击右上角【···】进入群聊设置页，点击【管理群】，找到【截屏通知】开关，开启后截屏，群成员均会收到通知。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==5">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">推荐给好友</span></div>
            <div>
              <p>推荐给好友<br>
                在【通讯录】列表中点击好友头像，进入对方主页，点击右上角【···】进入资料设置页，点击【推荐该联系人】。在弹出的联系人列表中勾选要分享的朋友，然后点击右上角的【确定】</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==6">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">推消息定时清理</span></div>
            <div>
              <p>单聊消息定时清理<br>
                在【通讯录】列表中点击好友头像，点【发送消息】进入对方聊天页面，点击右上角【···】进入聊天详情页，点击【消息定时清理】，开启后设置对应时间，会话中的消息已读后，将按设定的时间清理。<br><br>

                群聊消息定时清理<br>
                在【通讯录】列表中点击群聊，点【发送消息】进入对方聊天页面，点击右上角【···】进入聊天详情页，点击【消息定时清理】，开启后设置对应时间，会话中的消息已读后，将按设定的时间清理。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==7">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">为好友添加备注和分组</span></div>
            <div>
              <p>为好友添加备注<br>
                在【通讯录】列表中点击好友头像，点击【好友备注和分组】进入设置页面，输入你想为好友设置的昵称，再点击右上角的【完成】按钮即可。<br><br>

                为好友分组<br>
                在【通讯录】列表中点击好友头像，点击【好友备注和分组】进入设置页面，点击【分组】选择已有的分组，再点击右上角的【完成】按钮即可。<br><br>

                创建好友分组<br>
                在【通讯录】列表中点击【好友分组】进入分组页面，再点击右上角的【新建】进入分组新建页面，编辑该组名称，添加成员后，再点击右上角的【保存】<br><br>

                编辑好友分组<br>
                在【通讯录】列表中点击【好友分组】进入分组页面，选择要编辑的分组，左滑可删除分组，进入该组的编辑页面即可修改分组名称，继续添加成员，也可左滑删除成员，最后点击右上角的【保存】即可</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==8">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">举报违规用户</span></div>
            <div>
              <p>举报头像<br>
                在【通讯录】列表中点击好友头像，点右上角【...】进入资料设置页面，点击下方【举报头像】即可立即举报。<br><br>

                举报用户<br>
                在【通讯录】列表中点击好友头像，点右上角【...】进入资料设置页面，点击下方【被骚扰了？举报该用户】进入举报页，填写相关举报的资料即可。</p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-3" v-show="pcMenu1Index==3">
          <div class="pcMenu1One" v-show="gyqlIndex==-1">
            <div><span>关于群聊</span></div>
            <div>
              <p @click="gyqlIndex=1">1. 创建群聊</p>
              <p @click="gyqlIndex=2">2. 加入/退出群聊</p>
              <p @click="gyqlIndex=3">3. 群消息通知</p>
              <p @click="gyqlIndex=4">4. 发送福袋</p>
              <p @click="gyqlIndex=5">5. 发布群公告（群主/管理员）</p>
              <p @click="gyqlIndex=6">6. 编辑群资料（群主/管理员）</p>
              <p @click="gyqlIndex=7">7. 加群设置（群主/管理员）</p>
              <p @click="gyqlIndex=8">8. 群内禁言（群主/管理员）</p>
              <p @click="gyqlIndex=9">9. 群成员保护（群主/管理员）</p>
              <p @click="gyqlIndex=10">10. 群成员活跃度（群主/管理员）</p>
              <p @click="gyqlIndex=11">11. 群黑名单（群主/管理员）</p>
              <p @click="gyqlIndex=12">12. 群截屏通知（群主/管理员）</p>
              <p @click="gyqlIndex=13">13. 加群身份审批（群主/管理员）</p>
              <p @click="gyqlIndex=14">14. 发消息长度设置（群主/管理员）</p>
              <p @click="gyqlIndex=15">15. 群排名（群主/管理员）</p>
              <p @click="gyqlIndex=16">16. 增加群活跃点（群主/管理员）</p>
              <p @click="gyqlIndex=17">17. 群投票（VIP）</p>
              <p @click="gyqlIndex=18">18. 设置群管理（群主）</p>
              <p @click="gyqlIndex=19">19. 提升群人数（群主）</p>
              <p @click="gyqlIndex=20">20. 转让群（群主）</p>
              <p @click="gyqlIndex=21">21. 解散群（群主）</p>
              <p @click="gyqlIndex=22">22. 举报群（管理员/群成员）</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==1">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">创建群聊</span></div>
            <div>
              <p>创建群<br>
                在【消息】界面，点击右上角的【+】的图标，选择【创建群聊】，在选择好友页面中选择好群成员，再点击右上角的【继续】，在创建页面设置群名称、群头像、加群方式，点击右上角的【创建】即创建好了一个群。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==2">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">加入/退出群聊</span></div>
            <div>
              <p>加入群聊<br>
                主动申请加入：通过搜索群名称或群ID、扫描群二维码，可以加入群聊；被邀请加入：群成员可以在群聊详情页邀请自己的好友加入该群。若不希望被其他人邀请进群，可通过【我的-设置中心-隐私设置-禁止邀请我入群】。<br><br>

                退出群聊<br>
                主动退出：在群聊详情页，滑到底部点击【删除并退出】，可退出该群。被移除：群主或管理员可以在群聊详情页的群成员区域点击【-】移除群成员。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==3">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群消息通知</span></div>
            <div>
              <p>群聊消息通知<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；若不想收到消息可设置成【接收消息但不提醒】，若不想群聊出现在列表中可设置成【收进群助手且不提醒】。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==4">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">发送福袋</span></div>
            <div>
              <p>发送普通福袋<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【经验券福袋】，填写个数和选择总经验值，点击【发起福袋】即可。<br><br>

                发送特效福袋（SVIP）<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【经验券福袋】，选择【特效福袋】，填写个数和选择总经验值，然后点击【发起福袋】即可。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==5">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">发布群公告（群主/管理员）</span></div>
            <div>
              <p>发布群公告（群主/管理员）<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【群置顶消息】编辑置顶内容，然后点击右上角【完成】即可。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==6">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">编辑群资料（群主/管理员）</span></div>
            <div>
              <p>在与群组聊天窗口中，点击右上角的【...】，进入群聊设置，点击【管理群-编辑资料】或直接点击【群头像】<br><br>

                群昵称<br>
                修改群名称：在编辑资料页点击【群昵称】，进入群名称修改页，编辑后点击右上角的【完成】按钮即可。<br><br>

                群标签<br>
                添加群标签：在编辑资料页点击【群标签】，进入群标签页，可选择或自定义标签，最多3个标签。再点击底部【确定】按钮即可。<br><br>

                群地点<br>
                添加群标签：在编辑资料页点击【群地点】，进入地点选择页面，找到目标地点。再点击右上角【确定】按钮即可。<br><br>

                群介绍<br>
                添加群介绍：在编辑资料页点击【群介绍】，进入编辑页面，输入群介绍内容。再点击右上角【完成】按钮即可。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==7">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">加群设置（群主/管理员）</span></div>
            <div>
              <p>加群方式<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【加群方式】进入设置页，可以为该群选择群成员入群的方式。<br><br>

                群查找方式<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；滑到底部点击【管理群】，再点击【群查找方式】进入设置页，可以选择是否【允许被搜索】，如果允许群被搜索查找，还可在下方设置被查找的方式。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==8">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群内禁言（群主/管理员）</span></div>
            <div>
              <p>群员禁言<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【全员禁言】进入设置页，可设置全员禁言和设置时间段进行全员禁言，设置后群主/管理员不受禁言影响。<br><br>

                单个禁言<br>
                在与群组聊天窗口中，点击右上角的【...】，查看群成员列表中，点击某个群成员的头像，进入对方的群聊主页，就可对其设置群内禁言。<br>
                在群聊详情页点击【禁言列表】，可查看到所有被禁言的成员，可解除对他们的禁言。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==9">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群成员保护（群主/管理员）</span></div>
            <div>
              <p>群成员保护<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，即可开启【成员保护模式】，开启后，除群主和管理员可在群内查看群成员信息、添加群成员好友之外，群成员之间不能互相查看个人信息和添加好友。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==10">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群成员活跃度（群主/管理员）</span></div>
            <div>
              <p>群成员活跃度<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【群成员活跃度】，可查看一周、两周、一个月不活跃的情况，也可将活跃度不高的群成员移除群聊。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==11">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群黑名单（群主/管理员）</span></div>
            <div>
              <p>加入群黑名单<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【群黑名单】进入该页面，点击右上角的【+】就可选择群成员加入黑名单。<br><br>

                移除群黑名单<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【群黑名单】进入该页面，选择要移除的成员点击右下方的【删除】即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==12">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群截屏通知（群主/管理员）</span></div>
            <div>
              <p>群截屏通知<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【截屏通知】开关，开启后在群聊会话截屏将提示所有人。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==13">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">加群身份审批（群主/管理员）</span></div>
            <div>
              <p>加群身份审批<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【加群身份审批】设置审批条件，根据条件自动审核，符合进群身份条件才可申请加入该群聊，不符合条件将不能发起加群申请。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==14">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">发消息长度设置(群主/管理员)</span></div>
            <div>
              <p>发消息长度设置（群主/管理员）<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【消息长度设置】设置单条消息的字数限制1-500字。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==15">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群排名（群主/管理员）</span></div>
            <div>
              <p>群排名<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【群排名】开启则可让群参与排名。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==16">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">增加群活跃点（群主/管理员）</span></div>
            <div>
              <p>使用群活跃点券<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【增加群活跃点】，去使用【群活跃点券】使用成功后，当天该群的活跃点则会对应增加。<br>
                群活跃点越高，排名越靠前，曝光率就越好。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==17">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群投票（VIP）</span></div>
            <div>
              <p>群投票（VIP）<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击顶部右上角的【柱状图】图标，若是会员底部有一个【投票】按钮，点击即可投票。每天可投票一次，获得20活跃点。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==18">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">设置群管理（群主）</span></div>
            <div>
              <p>添加管理员<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【设置管理员】进入设置页面，点击【+】在群成员中选择管理员。<br><br>

                移除管理员<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【设置管理员】进入设置页面，点击右上角【编辑】后，选择要移除的管理员。<br>
                也可以直接在群成员列表中点击某成员头像，进入对方的群聊主页，设置或取消管理员身份。

              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==19">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">提升群人数（群主）</span></div>
            <div>
              <p>群截屏通知<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【提升群人数】达到相应条件即可升级群人数。

              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==20">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">转让群（群主）</span></div>
            <div>
              <p>转让群<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【转让群】，在群成员列表中选择要转让的热，在弹出的操作弹窗中点击【确定】即可将该群转让给新的群主。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==21">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">解散群（群主）</span></div>
            <div>
              <p>解散群<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；滑动至底部，点击【解散该群】，在弹窗的操作窗口中点击【确定】，即可解散该群。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==22">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">举报群(管理员/群成员)</span></div>
            <div>
              <p>举报群<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；滑动至底部，点击【被骚扰了？举报该群】，进入举报页，填写相关举报的资料即可。</p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-4" v-show="pcMenu1Index==4">
          <div class="pcMenu1One" v-show="gyltIndex==-1">
            <div><span>关于聊天</span></div>
            <div>
              <p @click="gyltIndex=1">1. 设置聊天背景</p>
              <p @click="gyltIndex=2">2. 语音/视频通话</p>
              <p @click="gyltIndex=3">3. 消息删除（单向删除）</p>
              <p @click="gyltIndex=4">4. 消息撤回（双向删除）</p>
              <p @click="gyltIndex=5">5. 聊天窗口删除/置顶</p>
              <p @click="gyltIndex=6">6. 发送消息</p>
              <p @click="gyltIndex=7">7. 添加自定义表情包</p>
              <p @click="gyltIndex=8">8. 消息免打扰</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==1">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">设置聊天背景</span></div>
            <div>
              <p>为好友设置聊天背景<br>
                打开您与好友的聊天页面，点击右上角的【...】,进入您与对方的聊天设置页，点击【设置聊天背景】，从相册选择或直接拍摄照片，就可以设置专属聊天背景。<br><br>

                为群组设置聊天背景<br>
                进入群聊的聊天页面，点击右上角的【...】,进入群聊详情页，滑动到底部，点击【设置当前聊天背景】，从相册选择或直接拍摄照片，就可以设置专属聊天背景。<br><br>

                设置通用聊天背景<br>
                在【我的-设置中心-通用-聊天背景】进入背景设置页面，从相册选择或直接拍摄照片。此处设置的聊天背景，将作为海鸥上所有聊天窗口的背景。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==2">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">语音/视频通话</span></div>
            <div>
              <p>单聊语音/视频通话<br>
                打开您与好友的聊天页面，点击输入框右边【+】展开更多聊天选项，再点击【视频】或【语音】，等待对方接通后就可进行语音或视频聊天。<br><br>

                群聊语音/视频通话<br>
                打开您与好友的聊天页面，点击输入框右边【+】展开更多聊天选项，再点击【语音】，需要双方都是SVIP才可发起通话。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==3">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">消息删除（单向删除）</span></div>
            <div>
              <p>单条消息删除<br>
                聊天页面中，长按某条消息，在出现的操作栏点击【删除】。<br><br>

                多条消息合并删除<br>
                聊天页面中，长按某条消息，在出现的操作栏点击【多选】，勾选要删除的消息，点击右下角的【删除】。<br><br>

                删除某聊天窗口的所有记录<br>
                在【消息】界面中选择要删除的单聊或群聊窗口，按住左滑，点击【删除】按钮，删除了某个聊天窗口，也就删除了该聊天窗口中的所有记录。<br><br>

                清空所有聊天记录<br>
                在【我的-设置中心-通用-清空所有聊天记录】点击后就可以将海鸥内所有聊天记录清空。<br><br>

                以上4种方式删除的都只是自己手机终端的聊天消息记录，对方手机终端不受影响。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==4">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">消息撤回（双向删除）</span></div>
            <div>
              <p>撤回单条消息<br>
                聊天页面中，长按某条消息，在出现的操作栏点击【撤回】。<br><br>

                单聊撤回所有消息<br>
                在单聊页面中，点击输入框右边的【小扫帚】，即可撤回你和对方的全部聊天记录。<br><br>

                群聊撤回所有消息<br>
                在群聊页面中，点击输入框右边的【小扫帚】，若你是群成员，可撤回你发的全部群消息；若你是群主或管理员，则可撤回所有人发的群消息，即该群的所有聊天记录。<br><br>

                撤回不同于单方面的删除，撤回是双向的删除，撤回消息将同时从你和聊天对象的设备上消失。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==5">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">聊天窗口删除/置顶</span></div>
            <div>
              <p>聊天删除/置顶<br>
                在【消息】界面中，选择聊天对话，按住左滑，就会出现【删除】和【置顶】按钮。点击【删除】即可删除该聊天窗口以及里面所有的聊天记录。点击【置顶】即可将该聊天窗口置顶。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==6">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">发送消息</span></div>
            <div>
              <p>发送文字<br>
                在聊天页面中输入文字内容，点击输入框左边【发送】按钮或者键盘右边的【发送】，即可发送。单条文字消息最多可输入500字。<br><br>

                发送语音<br>
                在聊天页面中点击输入框左边【语音】图标，会弹出【按住说话】按钮，长按此按钮即可进行录音，松开按钮该条语音讲自动发送给好友。在长按录音时，手指向左移动到【关闭】按钮，即可取消发送。<br><br>

                发送图片和视频<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【相册】，即可选图片或视频发送给好友；或者直接点击【拍摄】，进入拍摄页面，点击拍照，长按录像，完成后点击【使用照片/视频】发送。<br><br>

                发送位置<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【位置】，选择好位置后点击右上角的【确定】即可。<br><br>

                发送名片<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【名片】，选择要推荐的好友，该好友的名片就会自动发送给当前对象。<br><br>

                群喇叭<br>
                在聊天页面中点击输入框左上方的【群喇叭】，输入要发布的内容，点击右上角的【发布】。通过群喇叭发出去的消息，会在群聊窗口中置顶显示，让所有点开群聊窗口的成员都可以看到。<br><br>

                发送卡券<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【卡券】，选择需要赠送的卡券，点击右上角的【确定】按钮，就可以将卡券赠送给当前群聊或好友。<br><br>

                发送鸥币<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【赠币】，选择要赠送的鸥币数量，点击【赠送】即可。<br><br>
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==7">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">添加自定义表情包</span></div>
            <div>
              <p>添加自定义表情<br>
                在聊天窗口的表情系列中，点击心形的【收藏】按钮，再点击【+】，进入添加表情页面，再点击【+】进入手机相册选择表情图片，勾选好后点击相册右下角的【完成】按钮。<br><br>

                删除自定义表情<br>
                在聊天窗口的表情系列中，点击心形的【收藏】按钮，再点击【+】，进入添加表情页面，再点击【编辑】勾选要删除的表情，再点击右下角的【删除】
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==8">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">消息免打扰</span></div>
            <div>
              <p>单聊消息免打扰<br>
                在与好友聊天窗口中，点击右上角的【...】，进入聊天详情页，即可开启【消息免打扰】<br><br>

                群聊消息免打扰<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；若不想收到消息可设置成【接收消息但不提醒】，若不想群聊出现在列表中可设置成【收进群助手且不提醒】。
              </p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-5" v-show="pcMenu1Index==5">

          <div class="pcMenu1One" v-show="gytzIndex==-1">
            <div><span>关于通知</span></div>
            <div>
              <p @click="gytzIndex=1">1. 海鸥通知设置</p>
              <p @click="gytzIndex=2">2. 手机消息提醒说明</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="gytzIndex==1">
            <div><span @click="gytzIndex=-1">关于通知></span><span style="color: #333333;">海鸥通知设置</span></div>
            <div>
              <p>在【我的-设置中心-消息通知】进入通知设置页面，对海鸥消息进行设置。<br><br>

                海鸥打开/未开打的通知设置<br>
                在【海鸥未打开】的状态下，选择是否开启消息通知提醒；在【海鸥打开】的状态下，消息是默认没有铃声提醒的，这时候可以选择接收到消息是否伴有震动提醒。<br><br>

                安卓端手机设置内开启后台运行<br>
                在【海鸥未打开】的状态下，选择是否开启消息通知提醒；在【海鸥打开】的状态下，消息是默认没有铃声提醒的，这时候可以选择接收到消息是否伴有震动提醒。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gytzIndex==2">
            <div><span @click="gytzIndex=-1">关于通知></span><span style="color: #333333;">手机消息提醒说明</span></div>
            <div>
              <p>苹果手机消息提醒设置<br>
                通过手机中的【设置-通知】找到【海鸥】，开启【允许通知】。<br><br>

                华为手机消息提醒设置<br>
                通过手机中的【设置-通知中心】找到【海鸥】，开启【允许通知】，在下面的类别中设置通知形式。<br><br>

                小米手机消息提醒设置<br>
                通过手机中的【设置-通知与控制中心-通知管理】找到【海鸥】开启通知权限，点击进入详情页设置通知形式。<br><br>

                vivo手机消息提醒设置<br>
                通过手机中的【设置-状态栏与通知-通知管理】在应用列表找到【海鸥】开启【允许通知】并设置通知形式。<br><br>

                OPPO手机消息提醒设置<br>
                通过手机中的【设置-通知与状态栏】在应用列表找到【海鸥】开启【允许通知】并设置通知形式。<br><br>

                乐视手机消息提醒设置<br>
                通过手机中的【设置-通知管理】为【海鸥】开启通知权限，点击进入详情页设置通知形式。
              </p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-6" v-show="pcMenu1Index==6">

          <div class="pcMenu1One" v-show="gyscIndex==-1">
            <div><span>关于商城</span></div>
            <div>
              <p @click="gyscIndex=1">1. 卡券专区</p>
              <p @click="gyscIndex=2">2. 会员专区</p>
              <p @click="gyscIndex=3">3. 靓号专区</p>
              <p @click="gyscIndex=4">4. 鸥币专区</p>
              <p @click="gyscIndex=5">5. 其他专区</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==1">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">卡券专区</span></div>
            <div>
              <p>通过【我的-海鸥商城】进入海鸥商城界面，在【我的卡券】板块中可以查看自己拥有的所有卡券。<br><br>

                靓号券<br>
                可兑换当前的ID号，兑换后原ID将会被回收，可在【靓号专区-靓号广场】购买心仪的ID号。<br><br>

                经验券<br>
                经验券用于兑换经验值，可通过鸥币抽奖或商城购买经验券获得，也可通过别人赠送获得。<br><br>

                靓号服务券<br>
                靓号服务券用于兑换靓号服务，使用之后可获得靓号标识，1.3倍加速，昵称高亮显示。可在【靓号专区-靓号服务】购买获得。<br><br>

                会员券<br>
                会员券用于兑换等价值的会员，使用会员券后有相应铭牌显示、昵称高亮、1.3倍加速、隐藏ID号等功能。<br><br>

                群靓号券<br>
                可兑换当前群的ID号，兑换后原ID将会被回收，可在【靓号专区-群靓号广场】购买心仪的群ID号。<br><br>

                群靓号服务券<br>
                群靓号服务券用于兑换群靓号服务，使用之后可获得靓号标识，群昵称高亮显示。可在【靓号专区-群靓号服务】购买获得。<br><br>

                折扣券<br>
                折扣券用于购买海鸥商城的会员券、靓号服务券、靓号券等使用。可在【海鸥商城-鸥币抽奖】抽奖获得。<br><br>

                产品券<br>
                海鸥不定时出相应的活动。可在【海鸥商城-积分抽奖】抽奖获得。<br><br>

                唯名卡券<br>
                唯名卡修改唯一昵称仅支持当前1次操作，修改昵称提交成功后，再次修改昵称，唯名卡失效。可通过【海鸥商城-唯名卡-唯名卡购买】获得。<br><br>

                群管家券<br>
                使用群管家券后需要群主/管理员手动去该群【群聊设置】打开群管家开关，并设置相关管理权限。可通过【靓号专区-购买群管家】获得。<br><br>

                个人曝光卡<br>
                使用个人曝光卡后将获得相应人次曝光特权，如使用100人次曝光卡将会像100个可能感兴趣的用户推荐你的个人名片，增加你的曝光度。可通过【排行榜-日榜】排名第一获得。<br><br>

                群活跃点券<br>
                群活跃点券使用后可增加群的活跃点，活跃点越高群排名越靠前。可通过【海鸥商城-购买群活跃点券】获得。<br><br>

                群容量升级卡<br>
                群容量升级卡使用后不占有群主会员等级原有的超级群数量，群当前容量低于将要升级的容量方能使用群容量升级卡。可通过【海鸥商城-购买群容量升级卡】获得。<br><br>

                等级卡<br>
                使用等级卡后，可将当前账号等级直接升级为使用的相应等级卡等级，非SVIP用户不可使用等级卡，使用等级账号等级必须在对应等级范围方可使用。可通过【海鸥商城-购买等级卡】获得。<br><br>

                换绑卡<br>
                使用换绑卡后，无需查收原账号绑定的手机验证码即可立即换成新的手机号。可通过【海鸥商城-鸥币抽奖】获得。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==2">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">会员专区</span></div>
            <div>
              <p>通过【我的-海鸥商城】进入海鸥商城界面，在【会员专区】板块中可以开通会员、购买会员券、合成SVIP和购买等级卡。<br><br>

                开通会员<br>
                通过【海鸥商城-会员专区】进入会员中心，选择开通时间，点击【立即开通】，支付对应金额进行开通。<br><br>

                购买会员券<br>
                通过【海鸥商城-购买会员券】进入购买会员券，选择开通时间，点击【立即支付】后选择购买数量，支付对应金额。<br><br>

                靓号服务券<br>
                靓号服务券用于兑换靓号服务，使用之后可获得靓号标识，1.3倍加速，昵称高亮显示。可在【靓号专区-靓号服务】购买获得。<br><br>

                合成SVIP<br>
                通过【海鸥商城-合成SVIP】进入合成页面，需12张VIP券合成1张SVIP券<br><br>

                购买等级卡<br>
                可通过【海鸥商城-购买等级卡】获得。使用等级卡后，可将当前账号等级直接升级为使用的相应等级卡等级，非SVIP用户不可使用等级卡，使用等级账号等级必须在对应等级范围方可使用。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==3">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">靓号专区</span></div>
            <div>
              <p>靓号服务<br>
                开通靓号服务，可以点亮靓号身份铭牌、昵称高亮显示、获得1.3倍的经验成长值。在购买靓号时，会自动赠送一定时间的靓号服务。<br><br>

                靓号广场<br>
                如果要更换当前的ID号，可通过【我的-海鸥商城-靓号专区-靓号广场】进入购买，可直接购买替换当前ID，也可以购买靓号券。<br><br>

                群靓号<br>
                如果要更换某个群的ID号，可通过【我的-海鸥商城-靓号专区-群靓号】进入购买，可直接购买替换当前某个群的ID，也可以购买靓号券。<br><br>

                群靓号服务<br>
                通过【海鸥商城-靓号专区-群靓号服务】获得。使用后可点亮群身份铭牌，群昵称高亮，截屏通知。<br><br>

                购买群管家券<br>
                通过【海鸥商城-靓号专区-购买群管家券】购买获得。群管家有进群欢迎语、发言管理、自助问答、刷频检测、定时消息、群黑名单管理功能。<br><br>

                群容量升级<br>
                通过【海鸥商城-购买群容量升级卡】购买获得。群容量升级卡使用后不占有群主会员等级原有的超级群数量，群当前容量低于将要升级的容量方能使用群容量升级卡。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==4">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">鸥币专区</span></div>
            <div>
              <p>我的鸥币<br>
                在鸥币专区，点击【我的鸥币】进入鸥币详情页，在该页面可以查看你当前的积分，以及收入/支出的详细情况<br><br>

                鸥币充值<br>
                在鸥币专区，点击【我的鸥币】进入鸥币充值页面，选择需要充值的鸥币数量再点击【立即充值】即可；点击右上角的【鸥币明细】可查看鸥币的收入/支出明细。<br><br>

                鸥币抽奖<br>
                在【鸥币抽奖】，可以消耗鸥币来抽取奖品，奖品以实际转盘为准，不定时更新奖品。<br><br>

                个性装扮<br>
                在【个性装扮】中，会员可选择对应的气泡、头像框、进群特效、贵族专享头像。<br><br>

                积分抽奖<br>
                在【积分抽奖】，可以消耗积分来抽取奖品，奖品以实际转盘为准，不定时更新奖品。积分来源：不定时邀请好友可获得积分。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==5">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">其他专区</span></div>
            <div>
              <p>购买经验券<br>
                在其他专区，点击【购买经验券】进入购买页面，选择需要购买的经验券值，可以选择购买数量。<br><br>

                购买群活跃点<br>
                在其他专区，点击【购买群活跃点】进入购买页面，选择需要购买的经验券值，可以选择购买数量。<br><br>

                签到中心<br>
                在【签到中心】，每日签到可获得经验值，每日做任务也可获得经验值、会员、靓号服务。<br><br>

                卡券兑换<br>
                在【卡券兑换】中，30天靓号服务券、9折折扣券、8折折扣券、7折折扣券可兑换相应的鸥币。
              </p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-7" v-show="pcMenu1Index==7">
          <div class="pcMenu1One" v-show="yjqlIndex==-1">
            <div><span>一键清理</span></div>
            <div>
              <p @click="yjqlIndex=1">1. 一键清空聊天（单向)</p>
              <p @click="yjqlIndex=2">2. 一键已读消息</p>
              <p @click="yjqlIndex=3">3. 一键好友免打扰</p>
              <p @click="yjqlIndex=4">4. 一键删除好友</p>
              <p @click="yjqlIndex=5">5. 一键退出群聊</p>

              <p @click="yjqlIndex=6">6. 一键解散群聊（群主)</p>
              <p @click="yjqlIndex=7">7. 一键群聊免打扰</p>
              <p @click="yjqlIndex=8">8. 一键收进群助手</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==1">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键清空聊天（单向）</span></div>
            <div>
              <p>一键清空聊天<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【清空所有聊天】。<br>
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==2">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键已读消息</span></div>
            <div>
              <p>一键全部已读<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【全部标记已读】。<br>
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==3">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键好友免打扰</span></div>
            <div>
              <p>一键全部免打扰<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有好友】选择指定的好友后点击【一键免打扰】
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==4">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键删除好友</span></div>
            <div>
              <p>一键删除好友<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有好友】选择指定的好友后点击【删除好友】
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==5">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键退出群聊</span></div>
            <div>
              <p>一键退出群聊<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有群聊-我加入的群聊】选择想要退出的群聊，点击底部【一键退群】按钮即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==6">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键解散群聊（群主）</span></div>
            <div>
              <p>一键退出群聊<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有群聊-我创建的群聊】选择想要解散的群聊，点击底部【一键解散群】按钮即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==7">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键群聊免打扰</span></div>
            <div>
              <p>一键群聊免打扰<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有群聊-我加入的群聊/我创建的群聊】选择想要免打扰的群聊，点击底部【一键免打扰】按钮即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==8">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键收进群助手</span></div>
            <div>
              <p>一键收进群助手<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有群聊-我加入的群聊/我创建的群聊】选择想要收进群助手的群聊，点击底部【收进群助手】按钮即可。
              </p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-8" v-show="pcMenu1Index==8">
          <div class="pcMenu1One" v-show="gyqtIndex==-1">
            <div><span>关于其他</span></div>
            <div>
              <p @click="gyqtIndex=1">1. 邀请福利</p>
              <p @click="gyqtIndex=2">2. 排行榜</p>
              <p @click="gyqtIndex=3">3. 问题反馈</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyqtIndex==1">
            <div><span @click="gyqtIndex=-1">关于其他></span><span style="color: #333333;">邀请福利</span></div>
            <div>
              <p>邀请福利<br>
                在【发现-福利中心】界面中，点击【邀请好友领奖励】，再点击【邀请好友】，将自己的二维码名片分享出去，邀请好友注册使用海鸥APP，就可以获取相应的奖励。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqtIndex==2">
            <div><span @click="gyqtIndex=-1">关于其他></span><span style="color: #333333;">排行榜</span></div>
            <div>
              <p>查看排行榜<br>
                在【发现-等级排行】进入海鸥全球排行榜。排行榜分为日榜、周榜、总榜，每个榜单都是根据对应时间内获得的经验值进行排名的。例如：日榜是按照当日账号获得的经验值由大小从上至下排名。<br><br>

                参与排行榜排名<br>
                在【发现-等级排行】进入海鸥全球排行榜。需要经验值排在前100名，个人信息里不能包含违规违法信息即可参与。若不想参与排名点击右上角的【...】，选择【不参与排名】即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqtIndex==3">
            <div><span @click="gyqtIndex=-1">关于其他></span><span style="color: #333333;">问题反馈</span></div>
            <div>
              <p>问题反馈<br>
                在【我的-海鸥助手-意见反馈】填写你要反馈的问题后提交。也可以直接联系在线客服进行反馈问题。反馈问题不定时有奖励哦。
              </p>
            </div>
          </div>

        </div>

      </div>

      <div class="pc-menu2" v-show="menuIndex==2">
        <h1 style="text-align: center;">用户协议</h1>
        <div v-html="agreementMember" style="text-align: left;
    margin-left: 168px;
    margin-right: 168px;">

        </div>
      </div>

      <div class="pc-menu3" v-show="menuIndex==3">
        <h1 style="text-align: center;">隐私政策</h1>
        <div v-html="agreementPrivacy" style="text-align: left;
    margin-left: 168px;
    margin-right: 168px;">

        </div>
      </div>

      <div class="pc-menu4" v-show="menuIndex==4">
        <h1 style="text-align: center;">会员协议</h1>
        <div v-html="vipAgreement" style="text-align: left;
    margin-left: 168px;
    margin-right: 168px;">

        </div>
      </div>

    </div>

    <div id='mobile'>

      <div class="menu">
        <div :style="menuIndex==0?menuYes:menuNo" @click="onclick(0)"><span>常见问题</span></div>
        <div :style="menuIndex==1?menuYes:menuNo" @click="onclick(1)"><span>使用教程</span></div>
        <div :style="menuIndex==2?menuYes:menuNo" @click="onclick(2)"><span>用户协议</span></div>
        <div :style="menuIndex==3?menuYes:menuNo" @click="onclick(3)"><span>隐私政策</span></div>
        <div :style="menuIndex==4?menuYes:menuNo" @click="onclick(4)"><span>会员协议</span></div>

      </div>

      <div class="pc-menu0" v-show="menuIndex==0">
        <van-collapse v-model="activeName" accordion>

          <van-collapse-item title="海鸥是什么？" name="0">
            <div>
              <p>海鸥是一款安全稳定的强隐私陌生人社交聊天软件，可以随时随地收发信息，支持与好友音视频通话、一对一单聊，多人群聊，具有保护用户隐私安全的特色功能（截屏提醒、账号销毁等特色功能）。
                海鸥致力于用户社交信息安全加密，让用户真正体验到私密空间社交，不获取任何与软件使用无关的用户个人信息，不对任何聊天记录收集私密存储。注册体验即生成私钥，开启安全加密通信，防破解，防篡改，防窃听，防监控，为你解决通信风险，让您的聊天更加安全稳定。
              </p>
            </div>
          </van-collapse-item>

          <van-collapse-item title="怎么添加好友？" name="1">
            <div>
              <p> 一、搜索添加</p>
              <p>在聊天界面，点击右上角【+】的图标，选择【加好友/群】，通过搜索海鸥版号、昵称、手机号、标签添加好友。</p>
              <p>二、扫码添加</p>
              <p>在聊天界面，点击右上角【+】的图标，选择【扫一扫】，扫描对方的二维码名片即可添加，也可以将自己的二维码名片通过短信、微信、QQ分享出去，让好友扫码添加你。</p>
              <!-- <p>三、附近人添加</p>
              <p>在发现界面【附近人】列表可以对感兴趣的陌生人发消息，或请求添加为好友。</p> -->
            </div>
          </van-collapse-item>
          <van-collapse-item title="如何登录海鸥的PC版？" name="2">
            <div>
              <p>一、登录海鸥PC版</p>
              <p>
                使用浏览器访问https://www.haiouchat.com/，首页会出现windows下载，下载安装在电脑上后，用手机上的海鸥APP扫描该二维码，在弹出的页面中点击【登录】，即可在windows端使用海鸥。
                若扫描二维码无反应，先在海鸥APP的【聊天】界面顶部查看是否有pc端已登录提示，如果有先点击【退出pc端】，然后刷新网页上的二维码，再次扫描。 若还是不能登录，先检查一下网络连接是否正常，电脑时间是否为当地正常时间，如果均没有问题，按F5刷新再试试。
              </p>
              <p>二、退出海鸥PC版</p>
              <p>点击海鸥PC版左下角的【退出】按钮，在弹出的操作窗口中点击【确定】退出。也可以点击海鸥APP上【聊天】界面顶部的windows登录提示，进入登录信息页，点击【退出windows端】。</p>
            </div>
          </van-collapse-item>
          <van-collapse-item title="忘记密码怎么办？" name="3">
            <div>

              <p>海鸥版上的所有密码都是经过加密处理的，且未进行私密储存，一旦密码忘记，不能找回，只能重置。</p>
              <p>一、未登录状态</p>
              <p>
                在账号密码登录界面，点击密码输入框下的【忘记密码】选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入手机号获取验证码，重新两次设置新密码即可；第二种：【密保验证】先输入您的账号，再正确回答您设置的密保答案，重新两次设置新密码即可。
              </p>
              <p>二、已登录状态</p>
              <p>
                在【我的-设置-账号设置-登录密码】进入密码设置界面，点击【忘记旧密码】，选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入正确验证码后即可设置新的密码；第二种：【密保验证】正确回答您设置的密保答案，重新两次设置新密码即可。
              </p>
            </div>
          </van-collapse-item>
          <van-collapse-item title="如何防范网络诈骗？" name="4">
            <div>

              <p>1、看到“兼职、刷单、刷分、贷款、彩票、代理、返现、中奖、福利、兑换、手续费、保证金”等字眼时，一定要提高警惕。
                2、不熟悉的人发的链接不要轻易点开，不熟悉的人发的二维码不要轻易扫描；
                3、不要将自己的社交账号信息、购物支付账号信息、银行账户信息、付款码、收到的验证码，发送给不熟悉的人。
                4、要求先转账、先付款、先充值、先交手续费、先垫付本金再提供相应服务的，一定要提高警惕。
                5、声称某公司、某平台内部工作人员的，绝对不要轻信，请先联系其官方人员确认。
                6、自称是好友、亲人、领导等要求借款或缴纳钱款的，最好当面与其本人确认，不要贸然转账汇款。
                7、声称某网店、公司或网站客服，说误操作、订单有问题、账号被冻结的，绝对不要理会。
                8、声称公、检、法机构人员要求缴纳欠款，绝对不要付款，请先核实确认。
                9、不熟悉的人要求添加其他联系方式，到其他平台去聊天时，请慎重考虑。
                10、以交友的名义初步建立感情，然后以缺钱等名义让为其汇款的，绝对不要汇款。</p>
            </div>
          </van-collapse-item>
          <van-collapse-item title="什么是海鸥密信？" name="5">
            <div>

              <p>海鸥密信是海鸥系统中的电子邮件特色功能，支持全自动用数字证书加密每一封邮件和自动为每封发出的邮件盖上时间戳。海鸥版密信采用S/MIME国际标准加密电子邮件内容，S/MIME
                基于非对称加密，以保护您的电子邮件免受不必要的访问和篡改攻击。自动配置签名证书和加密证书。您可以放心地发送机密信息，可以放心地把所有机密信息和文件信息都加密发送到您的好友电子邮箱中，海鸥版全程加密发送保障机密信息不被窃取。
              </p>
            </div>
          </van-collapse-item>
          <van-collapse-item title="删除聊天记录后还能找回吗？" name="6">
            <div>
              <p>海鸥采用的是安全加密技术聊天，用户的聊天记录只会保存在用户的手机设备上，海鸥版平台不会进行聊天记录储存，用户一旦撤回或删除后，就将无法恢复找回，请谨慎操作。</p>
            </div>
          </van-collapse-item>

          <van-collapse-item title="如何举报？" name="7">
            <div>
              <p>在好友的资料详情页或群的详情页，点击右上角的三个小点【...】，就可以看到【举报/投诉】的入口，上传相关举报资料进行举报，我们收到信息后会尽快核实处理</p>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>

      <div class="pc-menu1" v-show="menuIndex==1">
        <div>
          <div :style="pcMenu1Index==0?mobileMenu1Yes:mobileMenu1YesNo" @click="onclickPcMenu1(0)"><img :src="pcMenu1Index==0?require('@/img/pc/Frame 1010104515@2x.png'):require('@/img/pc/Frame 1010104514@2x.png')" alt=""><span>常见问题</span></div>
          <div :style="pcMenu1Index==1?mobileMenu1Yes:mobileMenu1YesNo" @click="onclickPcMenu1(1)"><img :src="pcMenu1Index==1?require('@/img/pc/Frame@2x(1).png'):require('@/img/pc/Frame@2x.png')" alt=""><span>关于账号</span></div>
          <div :style="pcMenu1Index==2?mobileMenu1Yes:mobileMenu1YesNo" @click="onclickPcMenu1(2)"><img :src="pcMenu1Index==2?require('@/img/pc/Frame@2x(7).png'):require('@/img/pc/Frame@2x(6).png')" alt=""><span>关于好友</span></div>
          <div :style="pcMenu1Index==3?mobileMenu1Yes:mobileMenu1YesNo" @click="onclickPcMenu1(3)"><img :src="pcMenu1Index==3?require('@/img/pc/Frame@2x(5).png'):require('@/img/pc/Frame@2x(4).png')" alt=""><span>关于群聊</span></div>
          <div :style="pcMenu1Index==4?mobileMenu1Yes:mobileMenu1YesNo" @click="onclickPcMenu1(4)"><img :src="pcMenu1Index==4?require('@/img/pc/Frame@2x(3).png'):require('@/img/pc/Frame@2x(2).png')" alt=""><span>关于聊天</span></div>
          <div :style="pcMenu1Index==5?mobileMenu1Yes:mobileMenu1YesNo" @click="onclickPcMenu1(5)"><img :src="pcMenu1Index==5?require('@/img/pc/tongzhi@2x(1).png'):require('@/img/pc/tongzhi@2x.png')" alt=""><span>消息提醒</span></div>
          <div :style="pcMenu1Index==6?mobileMenu1Yes:mobileMenu1YesNo" @click="onclickPcMenu1(6)"><img :src="pcMenu1Index==6?require('@/img/pc/shangcheng@2x(1).png'):require('@/img/pc/shangcheng@2x.png')" alt=""><span>关于商城</span></div>
          <div :style="pcMenu1Index==7?mobileMenu1Yes:mobileMenu1YesNo" @click="onclickPcMenu1(7)"><img :src="pcMenu1Index==7?require('@/img/pc/Frame@2x(9).png'):require('@/img/pc/Frame@2x(8).png')" alt=""><span>一键清理</span></div>
          <div :style="pcMenu1Index==8?mobileMenu1Yes:mobileMenu1YesNo" @click="onclickPcMenu1(8)"><img :src="pcMenu1Index==8?require('@/img/pc/qita@2x(1).png'):require('@/img/pc/qita@2x.png')" alt=""><span>关于其他</span></div>

        </div>
        <div class="pc-menu1-0" v-show="pcMenu1Index==0">
          <div class="pcMenu1One" v-show="pcMenu10==-1">
            <div><span>常见问题</span></div>
            <div>
              <p @click="pcMenu10=1">1. 海鸥会员怎么购买？</p>
              <p @click="pcMenu10=2">2. 海鸥成长值说明</p>
              <p @click="pcMenu10=3">3. 忘记密码怎么办？</p>
              <p @click="pcMenu10=4">4. 聊天记录删除后还能找回吗？</p>
              <p @click="pcMenu10=5">5. 怎么添加好友/群聊？</p>
              <p @click="pcMenu10=6">6. 鸥币充值常见问题？</p>
              <p @click="pcMenu10=7">7. 如何防范网络诈骗？</p>
              <p @click="pcMenu10=8">8. 如何会员等级提升？</p>
              <p @click="pcMenu10=9">9. 群管家使用规则？</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==1">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">海鸥会员购买</span></div>
            <div>
              <p>如何使用微信/支付宝购买会员？</p>
              <p>（1）安卓手机</p>
              <p>通过【会员中心】>>选择【开通VIP/SVIP】>>选择【微信支付】或【支付宝支付】>>【下一步】按照步骤进行支付即可。</p>
              <p>（2）苹果手机</p>
              <p>暂不支持微信/支付宝购买，敬请期待。</p>
              <p>如何使用鸥币购买会员？</p>
              <p>（1）安卓手机</p>
              <p>安卓端暂不支持使用鸥币购买。</p>
              <p>（2）苹果手机</p>
              <p>鸥币购买会员目前仅苹果端支持购买会员券，通过【海鸥商城】>>选择【购买会员券】>>选择【鸥币支付】按照步骤进行支付即可。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==2">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">海鸥成长值说明</span></div>
            <div>
              <p>海鸥等级成长值说明</p>
              <p>用来评定用户会员等级的值称为成长值；用户可通过消费平台商品（除鸥币支付订单）获取成长值，从而提升尊贵会员等级。
              </p>
              <p>
                成长值换算比例：每消耗满10元=1成长值，未达到满10不计入成长值换算。所有消费需已支付并完成后可获得相应成长值，请勿违规刷成长值（包括但不限于虚假交易、恶意获取等
              </p>
              <p>行为）若发现存在违规行为，我们将取消您获取成长值的资格。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==3">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">忘记密码怎么办？</span></div>
            <div>
              <p>海鸥上的所有密码都是经过加密处理的，且未进行私密储存，一旦密码忘记，不能找回，只能重置。 </p>
              <p>未登录状态</p>
              <p>
                在账号密码登录界面，点击密码输入框下的【忘记密码】选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入手机号获取验证码，重新两次设置新密码即可；第二种：【密保验证】先输入您的账号，再正确回答您设置的密保答案，重新两次设置新密码即可。
              </p>
              <p>已登录状态</p>
              <p>
                在【我的-设置-账号设置-登录密码】进入密码设置界面，点击【忘记旧密码】，选择验证方式【短信验证/密保验证】；第一种：【短信验证】输入正确验证码后即可设置新的密码；第二种：【密保验证】正确回答您设置的密保答案，重新两次设置新密码即可。
              </p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==4">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">聊天记录删除后还能找回吗？</span></div>
            <div>
              <p>海鸥APP采用的是安全加密技术聊天，用户的聊天记录只会保存在用户的手机设备上，海鸥平台不会进行聊天记录储存，用户一旦撤回或删除后，就将无法恢复找回，请谨慎操作。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==5">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">怎么添加好友/群聊？</span></div>
            <div>
              <p>1. 搜索添加</p>
              <p>在聊天界面，点击右上角【+】的图标，选择【加好友/群】，通过搜索海鸥号、昵称、手机号、标签添加好友。</p>
              <p>2. 扫码添加</p>
              <p>在聊天界面，点击右上角【+】的图标，选择【扫一扫】，扫描对方的二维码名片即可添加，也可以将自己的二维码名片通过短信、微信、QQ分享出去，让好友扫码添加你。
              </p>
              <!-- <p>3. 附近人添加</p>
              <p>在发现界面【附近人】列表可以对感兴趣的陌生人发消息，或请求添加为好友。</p> -->
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==6">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">鸥币充值常见问题？</span></div>
            <div>
              <p>如何使用微信/支付宝购买会员？</p>
              <p>（1）安卓手机</p>
              <p>通过【会员中心】>>选择【开通VIP/SVIP】>>选择【微信支付】或【支付宝支付】>>【下一步】按照步骤进行支付即可。</p>
              <p>（2）苹果手机</p>
              <p>暂不支持微信/支付宝购买，敬请期待。</p>
              <p>如何使用鸥币购买会员？</p>
              <p>（1）安卓手机</p>
              <p>安卓端暂不支持使用鸥币购买。</p>
              <p>（2）苹果手机</p>
              <p>鸥币购买会员目前仅苹果端支持购买会员券，通过【海鸥商城】>>选择【购买会员券】>>选择【鸥币支付】按照步骤进行支付即可。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==7">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">如何防范网络诈骗？</span></div>
            <div>
              <p>
                海鸥APP是一款安全加密的聊天软件，与微信、钉钉一样，主要为用户提供聊天交友的相关功能。作为独立的聊天软件，海鸥版H版APP不归属于任何平台，若遇到冒充海鸥版客或假借海鸥版H版APP名义联系您的情况，请先联系海鸥版的唯一官方客服确认。<br>
                网络骗术层出不穷，请警惕任何利用聊天工具进行的欺诈行为，如娱乐平台充值、网络 贷款、兼职刷单、套现返现、网络彩票、色情服务等。若遇到此类情况，建议第一时间
                保存好相关资料，向相关平台或机构举报，并报警求助。<br>
                <br>
                海鸥防骗指南<br>
                （1）看到“兼职、刷单、刷分、贷款、彩票、代理、返现、中奖、福利、兑换、手续费、保证金”字眼时，一定要提高警惕。<br>
                （2）不熟悉的人发的链接不要轻易点开，不熟悉的人发的二维码不要轻易扫描；<br>
                （3）不要将自己的社交账号信息、购物支付账号信息、银行账户信息、付款码、收到的验证码，发送给不熟悉的人。<br>
                （4）要求先转账、先付款、先充值、先交手续费、先垫付本金再提供相应服务的，一定要提高警惕。<br>
                （5）声称某公司、某平台内部工作人员的，绝对不要轻信，请先联系其官方人员确认。<br>
                （6）自称是好友、亲人、领导等要求借款或缴纳钱款的，最好当面与其本人确认，不要贸然转账汇款。<br>
                （7）声称某网店、公司或网站客服，说误操作、订单有问题、账号被冻结的，绝对不要理会。<br>
                （8）声称公、检、法机构人员要求缴纳欠款，绝对不要付款，请先核实确认。<br>
                （9）不熟悉的人要求添加其他联系方式，到其他平台去聊天时，请慎重考虑。<br>
                （10）以交友的名义初步建立感情，然后以缺钱等名义让为其汇款的，绝对不要汇款。
              </p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==8">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">如何会员等级提升？</span></div>
            <div>
              <p>1. 等级有效期<br>
                海鸥会员等级在用户始终为会员身份期间，会一直保留尊贵等级身份，若用户会员身份到期后，或因用户其他原因导致会员到期后始终未续费，会员等级将不再降级，成长值也不会过期。<br><br>

                2. 升级规则<br>
                用户在会员等级有效期内产生消费（除鸥币支付订单）都会获得相应等级成长值，达到升级门槛值，新等级立即生效。用户如果已登顶，将继续累积成长值，成长值可赠送好友，会扣除自己相应成长值；封顶是20000成长值，如他有21000成长值
                其中20500成长值是别人赠送的，另外500成长值是自己消费所得的成长值；则只有500成长值是可赠送给他人。<br><br>

                3. 等级权益<br>
                不同的会员等级可享受该等级专属权益，我们将根据运营等实际情况不定期调整或更新，具体权益届时以页面展示为准。</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="pcMenu10==9">
            <div><span @click="pcMenu10=-1">常见问题></span><span style="color: #333333;">群管家使用规则？</span></div>
            <div>
              <p>功能说明<br>
                1）使用群管家券成功后，创建群将获得群管家使用入口，群主或管理员可以在群聊详情开启群管家并设置相关管理权限。已创建的群组可尊享【成员进群欢迎语】设置、【成员发言管理】设置、【成员自助问答】设置等便携群管服务。<br>
                2）本群管家券可转赠好友/群聊<br>
                3）若已使用群管家券，请提前及时续费，若到期后，该群聊将失去群管家功能及设置数据<br><br>

                获取方式<br>
                1）通过在【海鸥商城】-【购买群管家券】可以获取<br>
                2）通过好友赠送给自己<br><br>

                使用方式<br>
                1）【海鸥商城】-【群管家券】可以使用已拥有的群管家券。<br>
                2）群管家券可转赠他人，在【海鸥商城】-【群管家券】卡券详情里，点击【赠送好友】；也可以在单聊群聊聊天界面点击【+】-【卡券】中赠送</p>

            </div>

          </div>

        </div>

        <div class="pc-menu1-1" v-show="pcMenu1Index==1">
          <div class="pcMenu1One" v-show="gyzhIndex==-1">
            <div><span>关于账号</span></div>
            <div>
              <p @click="gyzhIndex=1">1. 注册账号</p>
              <p @click="gyzhIndex=2">2. 登录密码设置/修改</p>
              <p @click="gyzhIndex=3">3. 应用锁设置</p>
              <p @click="gyzhIndex=4">4. 密保问题</p>
              <p @click="gyzhIndex=5">5. 个人设置</p>
              <p @click="gyzhIndex=6">6. 更换手机号</p>
              <p @click="gyzhIndex=7">7. 等级和经验值</p>
              <p @click="gyzhIndex=8">8. 登录/退出</p>
              <p @click="gyzhIndex=9">9. 账号注销</p>
              <p @click="gyzhIndex=10">10. 账号申诉</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==1">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">注册账号</span></div>
            <div>
              <p>在应用市场搜索“海鸥”或“海鸥m”，找到海鸥APP，进行下载安装，也可以直接去海鸥官网<br>
                https://www.haiouchat.com去下载最新版本进行安装<br><br>

                在注册界面，输入正确的手机号，点击获取验证码，勾选同意《用户协议》和《隐私政策》，你将会得到一个海鸥ID号，表示注册成功。妥善保存好自己的ID，变异以后登录；也可以用注册的手机号验证码登录。若想使用其他ID号，可以到【海鸥商城-靓号专区】去购买。
              </p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==2">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">登录密码设置/修改</span></div>
            <div>
              <p>在登录页面，输入海鸥ID号和登录密码，就可以登录海鸥。<br><br>

                设置登录密码<br>
                登录密码在【我的-设置中心-账号安全-登录密码】中进行设置，密码至少8个字符，而且同时包含字母和数字。<br><br>

                修改登录密码<br>
                要修改登录密码，只需在登录密码设置页面输入正确的旧密码和要设置的新密码，点击【确定】即可。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==3">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">应用锁设置</span></div>
            <div>
              <p>应用锁类似于手机锁屏密码，开启后，则每次都需要通过解锁密码验证才能进入海鸥APP。<br><br>

                设置应用锁<br>
                应用锁在【我的-设置中心-账号安全-应用锁】中进行设置，输入两遍解锁密码后，可通过【锁屏时间】设置应用切换后进入密码锁定的时间。<br><br>

                修改应用锁密码<br>
                要修改应用锁密码，只需在应用锁密码设置页面点击【更改解锁密码】输入正确的旧密码和要设置的新密码。若忘记了原解锁密码可以点击【忘记应锁密码】按【确定】按钮，重新登录即可重新设置应用锁密码。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==4">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">密保问题</span></div>
            <div>
              <p>密保问题可以用来重置登录密码。<br><br>

                设置和修改密保问题<br>
                密保问题在【我的-设置中心-账号安全-密保问题】中进行设置，要修改密保问题需要验证原密保的答案，就可以重新设置。若忘记原来的密保问题和答案，可在密保设置页点击【忘记密保】，通过绑定的手机号来重新设置密保。<br><br>

                通过密保问题重置密码<br>
                重置登录密码。在修改密码时，点击【忘记旧密码】通过密保问题，重新设置登录密码。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==5">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">个人设置</span></div>
            <div>
              <p>在【我的】页面点击顶部的个人头像，进入个人信息页面，即可对你的头像、昵称、性别、生日、地区、个人标签、个性签名等进行设置，也可以复制自己的海鸥号，保存和分享自己的二维码名片。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==6">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">更换手机号</span></div>
            <div>
              <p>使用验证码直接修改手机号<br>
                修改手机号在【我的-设置中心-手机号码】中点击【更换绑定手机号】进行更改，需要填写完整的手机号，然后输入短信验证码进行验证换绑新的手机号。更换成功后，可使用新的手机号和验证码登录海鸥。<br><br>

                连续登录可直接修改手机号<br>
                修改手机号在【我的-设置中心-手机号码】中点击【我已经换号】进入换绑手机号满足的所需要的天数可获得 1 次换绑机会，每个ID号仅限 3 次换绑。直接输入新手机号和验证码即可换绑成功。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==7">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">等级和经验值</span></div>
            <div>
              <p>查看账号等级和经验值<br>
                通过【我的-海鸥等级】进入海鸥等级信息页面，可查看自己账号当前等级、当前经验值、成长速度；以及加入海鸥总天数等。<br><br>

                查看成长攻略（经验值获取）<br>
                想要提升账号等级，就需要不断积累获得经验值。在账号等级页面，点击右上角的【查看成长攻略】，进入海鸥成长体系，即可查看海鸥经验值获取方式，以及海鸥等级与所需经验值对照表。经验值不仅可用于海鸥账号等级的提升，还决定用户排行榜的排名。
              </p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==8">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">登录/退出</span></div>
            <div>
              <p>账号登录<br>
                海鸥有【手机号+验证码】、【海鸥号+密码】两种登录方式，在登录界面按钮下方有切换登录方式。<br>
                在【我的-设置中心-账号安全-登录设置】中，可以禁止用密码登录、禁止使用验证码登录、新设备需要验证。若禁用手机验证码登录，海鸥将收不触发对应的验证码发送，同样意味着不可再通过手机验证码来设置修改密码、密保。<br><br>

                账号退出<br>
                在【我的-设置中心-账号管理】中点击退出账号，在弹出的操作提示中点击【确定退出】<br><br>

                切换账号<br>
                在【我的-设置中心-账号管理】中点击添加账号后，可快捷切换登录其他海鸥账号。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==9">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">账号注销</span></div>
            <div>
              <p>在【我的-设置中心-账号安全-注销账号】中选择【立即销毁】，或选择一个自动注销时间，如果在这个时间里，一直未登录使用海鸥，账号就会自动注销。<br>
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyzhIndex==10">
            <div><span @click="gyzhIndex=-1">关于账号></span><span style="color: #333333;">账号申诉</span></div>
            <div>
              <p>在【我的-设置中心-账号安全-注销账号】中选择【立即销毁】，或选择一个自动注销时间，如果在这个时间里，一直未登录使用海鸥，账号就会自动注销。<br> </p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-2" v-show="pcMenu1Index==2">
          <div class="pcMenu1One" v-show="gyhyIndex==-1">
            <div><span>关于好友</span></div>
            <div>
              <p @click="gyhyIndex=1">1. 添加好友</p>
              <p @click="gyhyIndex=2">2. 删除好友</p>
              <p @click="gyhyIndex=3">3. 拉黑好友</p>
              <!-- <p @click="gyhyIndex=4">4. 阅后即焚</p> -->
              <p @click="gyhyIndex=4">4. 截屏通知</p>
              <p @click="gyhyIndex=5">5. 推荐给好友</p>
              <p @click="gyhyIndex=6">6. 消息定时清理</p>
              <p @click="gyhyIndex=7">7. 为好友添加备注和分组</p>
              <p @click="gyhyIndex=8">8. 举报违规用户</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==1">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">添加好友</span></div>
            <div>
              <p>搜索添加<br>
                在【消息】或【通讯录】界面，点击右上角的【+】的图标，选择【加好友/群】，通过搜索海鸥号、昵称、手机号、标签添加好友。<br>
                也可以使用右边【扫一扫】图标，扫描对方的二维码名片添加好友，或将自己的二维码名片通过短信、微信、QQ等方式分享出去，让对方扫描添加你。<br><br>

                排行榜添加<br>
                在【发现-等级排行】页面，可对感兴趣的陌生人加好友。若对方接受你的好友申请，你们即可成为好友进行聊天。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==2">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">删除好友</span></div>
            <div>
              <p>在【通讯录】列表中点击好友头像，进入对方主页，点击右上角【···】进入资料设置页，点击【删除】。删除后对方不再出现在您的联系人列表中，你们再也不能进行聊天。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==3">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">拉黑好友</span></div>
            <div>
              <p>加入黑名单<br>
                在【通讯录】列表中点击好友头像，进入对方主页，点击右上角【···】进入资料设置页，点击【加入黑名单】。拉黑后对方不再出现在您的联系人列表中，你将不会收到对方的消息。<br><br>

                移出黑名单<br>
                在【我的-设置中心-隐私】中点击【黑名单】，点击想要移出的联系人，弹窗提示【移出黑名单】</p>
            </div>

          </div>

          <!-- <div class="pcMenu1Two" v-show="gyhyIndex==4">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">阅后即焚</span></div>
            <div>
              <p>单聊阅后即焚<br>
                在【通讯录】列表中点击好友头像，点【发送消息】进入对方聊天页面，点击右上角【···】进入聊天详情页，点击【阅后即焚】，然后设置对应的秒数，消息已读后将自动销毁。<br><br>

                群聊阅后即焚<br>
                在【通讯录】列表中点击群聊，进入群聊页面，点击右上角【···】进入群聊设置页，点击【阅后即焚】，然后设置对应的秒数，消息已读后将自动销毁。</p>
            </div>
          </div> -->

          <div class="pcMenu1Two" v-show="gyhyIndex==4">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">截屏通知</span></div>
            <div>
              <p>单聊截屏通知<br>
                在【通讯录】列表中点击好友头像，点【发送消息】进入对方聊天页面，点击右上角【···】进入聊天详情页，点击【截屏通知】，开启后截屏，双方均会收到通知。<br><br>

                群聊截屏通知（群主/管理员）<br>
                在【通讯录】列表中点击群聊，进入群聊页面，点击右上角【···】进入群聊设置页，点击【管理群】，找到【截屏通知】开关，开启后截屏，群成员均会收到通知。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==5">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">推荐给好友</span></div>
            <div>
              <p>推荐给好友<br>
                在【通讯录】列表中点击好友头像，进入对方主页，点击右上角【···】进入资料设置页，点击【推荐该联系人】。在弹出的联系人列表中勾选要分享的朋友，然后点击右上角的【确定】</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==6">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">推消息定时清理</span></div>
            <div>
              <p>单聊消息定时清理<br>
                在【通讯录】列表中点击好友头像，点【发送消息】进入对方聊天页面，点击右上角【···】进入聊天详情页，点击【消息定时清理】，开启后设置对应时间，会话中的消息已读后，将按设定的时间清理。<br><br>

                群聊消息定时清理<br>
                在【通讯录】列表中点击群聊，点【发送消息】进入对方聊天页面，点击右上角【···】进入聊天详情页，点击【消息定时清理】，开启后设置对应时间，会话中的消息已读后，将按设定的时间清理。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==7">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">为好友添加备注和分组</span></div>
            <div>
              <p>为好友添加备注<br>
                在【通讯录】列表中点击好友头像，点击【好友备注和分组】进入设置页面，输入你想为好友设置的昵称，再点击右上角的【完成】按钮即可。<br><br>

                为好友分组<br>
                在【通讯录】列表中点击好友头像，点击【好友备注和分组】进入设置页面，点击【分组】选择已有的分组，再点击右上角的【完成】按钮即可。<br><br>

                创建好友分组<br>
                在【通讯录】列表中点击【好友分组】进入分组页面，再点击右上角的【新建】进入分组新建页面，编辑该组名称，添加成员后，再点击右上角的【保存】<br><br>

                编辑好友分组<br>
                在【通讯录】列表中点击【好友分组】进入分组页面，选择要编辑的分组，左滑可删除分组，进入该组的编辑页面即可修改分组名称，继续添加成员，也可左滑删除成员，最后点击右上角的【保存】即可</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyhyIndex==8">
            <div><span @click="gyhyIndex=-1">关于好友></span><span style="color: #333333;">举报违规用户</span></div>
            <div>
              <p>举报头像<br>
                在【通讯录】列表中点击好友头像，点右上角【...】进入资料设置页面，点击下方【举报头像】即可立即举报。<br><br>

                举报用户<br>
                在【通讯录】列表中点击好友头像，点右上角【...】进入资料设置页面，点击下方【被骚扰了？举报该用户】进入举报页，填写相关举报的资料即可。</p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-3" v-show="pcMenu1Index==3">
          <div class="pcMenu1One" v-show="gyqlIndex==-1">
            <div><span>关于群聊</span></div>
            <div>
              <p @click="gyqlIndex=1">1. 创建群聊</p>
              <p @click="gyqlIndex=2">2. 加入/退出群聊</p>
              <p @click="gyqlIndex=3">3. 群消息通知</p>
              <p @click="gyqlIndex=4">4. 发送福袋</p>
              <p @click="gyqlIndex=5">5. 发布群公告（群主/管理员）</p>
              <p @click="gyqlIndex=6">6. 编辑群资料（群主/管理员）</p>
              <p @click="gyqlIndex=7">7. 加群设置（群主/管理员）</p>
              <p @click="gyqlIndex=8">8. 群内禁言（群主/管理员）</p>
              <p @click="gyqlIndex=9">9. 群成员保护（群主/管理员）</p>
              <p @click="gyqlIndex=10">10. 群成员活跃度（群主/管理员）</p>
              <p @click="gyqlIndex=11">11. 群黑名单（群主/管理员）</p>
              <p @click="gyqlIndex=12">12. 群截屏通知（群主/管理员）</p>
              <p @click="gyqlIndex=13">13. 加群身份审批（群主/管理员）</p>
              <p @click="gyqlIndex=14">14. 发消息长度设置（群主/管理员）</p>
              <p @click="gyqlIndex=15">15. 群排名（群主/管理员）</p>
              <p @click="gyqlIndex=16">16. 增加群活跃点（群主/管理员）</p>
              <p @click="gyqlIndex=17">17. 群投票（VIP）</p>
              <p @click="gyqlIndex=18">18. 设置群管理（群主）</p>
              <p @click="gyqlIndex=19">19. 提升群人数（群主）</p>
              <p @click="gyqlIndex=20">20. 转让群（群主）</p>
              <p @click="gyqlIndex=21">21. 解散群（群主）</p>
              <p @click="gyqlIndex=22">22. 举报群（管理员/群成员）</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==1">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">创建群聊</span></div>
            <div>
              <p>创建群<br>
                在【消息】界面，点击右上角的【+】的图标，选择【创建群聊】，在选择好友页面中选择好群成员，再点击右上角的【继续】，在创建页面设置群名称、群头像、加群方式，点击右上角的【创建】即创建好了一个群。</p>
            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==2">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">加入/退出群聊</span></div>
            <div>
              <p>加入群聊<br>
                主动申请加入：通过搜索群名称或群ID、扫描群二维码，可以加入群聊；被邀请加入：群成员可以在群聊详情页邀请自己的好友加入该群。若不希望被其他人邀请进群，可通过【我的-设置中心-隐私设置-禁止邀请我入群】。<br><br>

                退出群聊<br>
                主动退出：在群聊详情页，滑到底部点击【删除并退出】，可退出该群。被移除：群主或管理员可以在群聊详情页的群成员区域点击【-】移除群成员。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==3">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群消息通知</span></div>
            <div>
              <p>群聊消息通知<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；若不想收到消息可设置成【接收消息但不提醒】，若不想群聊出现在列表中可设置成【收进群助手且不提醒】。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==4">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">发送福袋</span></div>
            <div>
              <p>发送普通福袋<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【经验券福袋】，填写个数和选择总经验值，点击【发起福袋】即可。<br><br>

                发送特效福袋（SVIP）<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【经验券福袋】，选择【特效福袋】，填写个数和选择总经验值，然后点击【发起福袋】即可。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==5">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">发布群公告（群主/管理员）</span></div>
            <div>
              <p>发布群公告（群主/管理员）<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【群置顶消息】编辑置顶内容，然后点击右上角【完成】即可。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==6">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">编辑群资料（群主/管理员）</span></div>
            <div>
              <p>在与群组聊天窗口中，点击右上角的【...】，进入群聊设置，点击【管理群-编辑资料】或直接点击【群头像】<br><br>

                群昵称<br>
                修改群名称：在编辑资料页点击【群昵称】，进入群名称修改页，编辑后点击右上角的【完成】按钮即可。<br><br>

                群标签<br>
                添加群标签：在编辑资料页点击【群标签】，进入群标签页，可选择或自定义标签，最多3个标签。再点击底部【确定】按钮即可。<br><br>

                群地点<br>
                添加群标签：在编辑资料页点击【群地点】，进入地点选择页面，找到目标地点。再点击右上角【确定】按钮即可。<br><br>

                群介绍<br>
                添加群介绍：在编辑资料页点击【群介绍】，进入编辑页面，输入群介绍内容。再点击右上角【完成】按钮即可。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==7">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">加群设置（群主/管理员）</span></div>
            <div>
              <p>加群方式<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【加群方式】进入设置页，可以为该群选择群成员入群的方式。<br><br>

                群查找方式<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；滑到底部点击【管理群】，再点击【群查找方式】进入设置页，可以选择是否【允许被搜索】，如果允许群被搜索查找，还可在下方设置被查找的方式。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==8">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群内禁言（群主/管理员）</span></div>
            <div>
              <p>群员禁言<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【全员禁言】进入设置页，可设置全员禁言和设置时间段进行全员禁言，设置后群主/管理员不受禁言影响。<br><br>

                单个禁言<br>
                在与群组聊天窗口中，点击右上角的【...】，查看群成员列表中，点击某个群成员的头像，进入对方的群聊主页，就可对其设置群内禁言。<br>
                在群聊详情页点击【禁言列表】，可查看到所有被禁言的成员，可解除对他们的禁言。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==9">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群成员保护（群主/管理员）</span></div>
            <div>
              <p>群成员保护<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，即可开启【成员保护模式】，开启后，除群主和管理员可在群内查看群成员信息、添加群成员好友之外，群成员之间不能互相查看个人信息和添加好友。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==10">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群成员活跃度（群主/管理员）</span></div>
            <div>
              <p>群成员活跃度<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【群成员活跃度】，可查看一周、两周、一个月不活跃的情况，也可将活跃度不高的群成员移除群聊。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==11">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群黑名单（群主/管理员）</span></div>
            <div>
              <p>加入群黑名单<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【群黑名单】进入该页面，点击右上角的【+】就可选择群成员加入黑名单。<br><br>

                移除群黑名单<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【群黑名单】进入该页面，选择要移除的成员点击右下方的【删除】即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==12">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群截屏通知（群主/管理员）</span></div>
            <div>
              <p>群截屏通知<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【截屏通知】开关，开启后在群聊会话截屏将提示所有人。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==13">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">加群身份审批（群主/管理员）</span></div>
            <div>
              <p>加群身份审批<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【加群身份审批】设置审批条件，根据条件自动审核，符合进群身份条件才可申请加入该群聊，不符合条件将不能发起加群申请。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==14">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">发消息长度设置(群主/管理员)</span></div>
            <div>
              <p>发消息长度设置（群主/管理员）<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【消息长度设置】设置单条消息的字数限制1-500字。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==15">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群排名（群主/管理员）</span></div>
            <div>
              <p>群排名<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【群排名】开启则可让群参与排名。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==16">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">增加群活跃点（群主/管理员）</span></div>
            <div>
              <p>使用群活跃点券<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【增加群活跃点】，去使用【群活跃点券】使用成功后，当天该群的活跃点则会对应增加。<br>
                群活跃点越高，排名越靠前，曝光率就越好。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==17">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">群投票（VIP）</span></div>
            <div>
              <p>群投票（VIP）<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击顶部右上角的【柱状图】图标，若是会员底部有一个【投票】按钮，点击即可投票。每天可投票一次，获得20活跃点。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==18">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">设置群管理（群主）</span></div>
            <div>
              <p>添加管理员<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【设置管理员】进入设置页面，点击【+】在群成员中选择管理员。<br><br>

                移除管理员<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【设置管理员】进入设置页面，点击右上角【编辑】后，选择要移除的管理员。<br>
                也可以直接在群成员列表中点击某成员头像，进入对方的群聊主页，设置或取消管理员身份。

              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==19">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">提升群人数（群主）</span></div>
            <div>
              <p>群截屏通知<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【提升群人数】达到相应条件即可升级群人数。

              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==20">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">转让群（群主）</span></div>
            <div>
              <p>转让群<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；点击【管理群】，再点击【转让群】，在群成员列表中选择要转让的热，在弹出的操作弹窗中点击【确定】即可将该群转让给新的群主。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==21">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">解散群（群主）</span></div>
            <div>
              <p>解散群<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；滑动至底部，点击【解散该群】，在弹窗的操作窗口中点击【确定】，即可解散该群。</p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqlIndex==22">
            <div><span @click="gyqlIndex=-1">关于群聊></span><span style="color: #333333;">举报群(管理员/群成员)</span></div>
            <div>
              <p>举报群<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；滑动至底部，点击【被骚扰了？举报该群】，进入举报页，填写相关举报的资料即可。</p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-4" v-show="pcMenu1Index==4">
          <div class="pcMenu1One" v-show="gyltIndex==-1">
            <div><span>关于聊天</span></div>
            <div>
              <p @click="gyltIndex=1">1. 设置聊天背景</p>
              <p @click="gyltIndex=2">2. 语音/视频通话</p>
              <p @click="gyltIndex=3">3. 消息删除（单向删除）</p>
              <p @click="gyltIndex=4">4. 消息撤回（双向删除）</p>
              <p @click="gyltIndex=5">5. 聊天窗口删除/置顶</p>
              <p @click="gyltIndex=6">6. 发送消息</p>
              <p @click="gyltIndex=7">7. 添加自定义表情包</p>
              <p @click="gyltIndex=8">8. 消息免打扰</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==1">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">设置聊天背景</span></div>
            <div>
              <p>为好友设置聊天背景<br>
                打开您与好友的聊天页面，点击右上角的【...】,进入您与对方的聊天设置页，点击【设置聊天背景】，从相册选择或直接拍摄照片，就可以设置专属聊天背景。<br><br>

                为群组设置聊天背景<br>
                进入群聊的聊天页面，点击右上角的【...】,进入群聊详情页，滑动到底部，点击【设置当前聊天背景】，从相册选择或直接拍摄照片，就可以设置专属聊天背景。<br><br>

                设置通用聊天背景<br>
                在【我的-设置中心-通用-聊天背景】进入背景设置页面，从相册选择或直接拍摄照片。此处设置的聊天背景，将作为海鸥上所有聊天窗口的背景。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==2">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">语音/视频通话</span></div>
            <div>
              <p>单聊语音/视频通话<br>
                打开您与好友的聊天页面，点击输入框右边【+】展开更多聊天选项，再点击【视频】或【语音】，等待对方接通后就可进行语音或视频聊天。<br><br>

                群聊语音/视频通话<br>
                打开您与好友的聊天页面，点击输入框右边【+】展开更多聊天选项，再点击【语音】，需要双方都是SVIP才可发起通话。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==3">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">消息删除（单向删除）</span></div>
            <div>
              <p>单条消息删除<br>
                聊天页面中，长按某条消息，在出现的操作栏点击【删除】。<br><br>

                多条消息合并删除<br>
                聊天页面中，长按某条消息，在出现的操作栏点击【多选】，勾选要删除的消息，点击右下角的【删除】。<br><br>

                删除某聊天窗口的所有记录<br>
                在【消息】界面中选择要删除的单聊或群聊窗口，按住左滑，点击【删除】按钮，删除了某个聊天窗口，也就删除了该聊天窗口中的所有记录。<br><br>

                清空所有聊天记录<br>
                在【我的-设置中心-通用-清空所有聊天记录】点击后就可以将海鸥内所有聊天记录清空。<br><br>

                以上4种方式删除的都只是自己手机终端的聊天消息记录，对方手机终端不受影响。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==4">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">消息撤回（双向删除）</span></div>
            <div>
              <p>撤回单条消息<br>
                聊天页面中，长按某条消息，在出现的操作栏点击【撤回】。<br><br>

                单聊撤回所有消息<br>
                在单聊页面中，点击输入框右边的【小扫帚】，即可撤回你和对方的全部聊天记录。<br><br>

                群聊撤回所有消息<br>
                在群聊页面中，点击输入框右边的【小扫帚】，若你是群成员，可撤回你发的全部群消息；若你是群主或管理员，则可撤回所有人发的群消息，即该群的所有聊天记录。<br><br>

                撤回不同于单方面的删除，撤回是双向的删除，撤回消息将同时从你和聊天对象的设备上消失。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==5">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">聊天窗口删除/置顶</span></div>
            <div>
              <p>聊天删除/置顶<br>
                在【消息】界面中，选择聊天对话，按住左滑，就会出现【删除】和【置顶】按钮。点击【删除】即可删除该聊天窗口以及里面所有的聊天记录。点击【置顶】即可将该聊天窗口置顶。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==6">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">发送消息</span></div>
            <div>
              <p>发送文字<br>
                在聊天页面中输入文字内容，点击输入框左边【发送】按钮或者键盘右边的【发送】，即可发送。单条文字消息最多可输入500字。<br><br>

                发送语音<br>
                在聊天页面中点击输入框左边【语音】图标，会弹出【按住说话】按钮，长按此按钮即可进行录音，松开按钮该条语音讲自动发送给好友。在长按录音时，手指向左移动到【关闭】按钮，即可取消发送。<br><br>

                发送图片和视频<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【相册】，即可选图片或视频发送给好友；或者直接点击【拍摄】，进入拍摄页面，点击拍照，长按录像，完成后点击【使用照片/视频】发送。<br><br>

                发送位置<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【位置】，选择好位置后点击右上角的【确定】即可。<br><br>

                发送名片<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【名片】，选择要推荐的好友，该好友的名片就会自动发送给当前对象。<br><br>

                群喇叭<br>
                在聊天页面中点击输入框左上方的【群喇叭】，输入要发布的内容，点击右上角的【发布】。通过群喇叭发出去的消息，会在群聊窗口中置顶显示，让所有点开群聊窗口的成员都可以看到。<br><br>

                发送卡券<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【卡券】，选择需要赠送的卡券，点击右上角的【确定】按钮，就可以将卡券赠送给当前群聊或好友。<br><br>

                发送鸥币<br>
                在聊天页面中点击输入框右边的【+】,在展开列表中点击【赠币】，选择要赠送的鸥币数量，点击【赠送】即可。<br><br>
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==7">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">添加自定义表情包</span></div>
            <div>
              <p>添加自定义表情<br>
                在聊天窗口的表情系列中，点击心形的【收藏】按钮，再点击【+】，进入添加表情页面，再点击【+】进入手机相册选择表情图片，勾选好后点击相册右下角的【完成】按钮。<br><br>

                删除自定义表情<br>
                在聊天窗口的表情系列中，点击心形的【收藏】按钮，再点击【+】，进入添加表情页面，再点击【编辑】勾选要删除的表情，再点击右下角的【删除】
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyltIndex==8">
            <div><span @click="gyltIndex=-1">关于聊天></span><span style="color: #333333;">消息免打扰</span></div>
            <div>
              <p>单聊消息免打扰<br>
                在与好友聊天窗口中，点击右上角的【...】，进入聊天详情页，即可开启【消息免打扰】<br><br>

                群聊消息免打扰<br>
                在与群组聊天窗口中，点击右上角的【...】，进入群聊设置；若不想收到消息可设置成【接收消息但不提醒】，若不想群聊出现在列表中可设置成【收进群助手且不提醒】。
              </p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-5" v-show="pcMenu1Index==5">

          <div class="pcMenu1One" v-show="gytzIndex==-1">
            <div><span>消息提醒</span></div>
            <div>
              <p>手机收不到消息提醒怎么办？</p>
              <p>• 导致原因</p>
              <p>部分手机系统在黑屏待机后自动清理后台运行软件，这样影响了海鸥正常接收新的消息，需要将海鸥这类软件设置为后台运行应用。</p>
              <p>PS：如果你能接收消息通知，请忽略</p>
              <p @click="gytzIndex=1">• 海鸥通知设置 <span style="color: #4371FF;">点击查看></span></p>
              <p @click="gytzIndex=2">• 手机消息设置(苹果、华为、小米、vivo、OPPO、乐视) <span style="color: #4371FF;">点击查看></span></p>
              <p @click="gytzIndex=3">• 苹果手机消息设置 <span style="color: #4371FF;">点击查看></span></p>

            </div>

            <div><span>安卓 <span style="color: #EB4D3D;">8.0及以上</span> 系统各类机型的设置说明：</span></div>
            <van-collapse v-model="activeName" accordion>

              <van-collapse-item title="(1)、华为荣耀手机设置说明" name="华为荣耀手机设置说明1">
                <div>
                  <img style="width: 100%;" src="@/img/notice/1.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(2)、OPPO手机设置说明" name="、OPPO手机设置说明1">
                <div>
                  <img style="width: 100%;" src="@/img/notice/2.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(3)、vivo手机设置说明" name="vivo手机设置说明1">
                <div>
                  <img style="width: 100%;" src="@/img/notice/3.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(4)、小米/红米手机设置说明" name="小米/红米手机设置说明1">
                <div>
                  <img style="width: 100%;" src="@/img/notice/4.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(5)、一加手机设置说明" name="一加手机设置说明1">
                <div>
                  <img style="width: 100%;" src="@/img/notice/5.png" alt="">
                </div>
              </van-collapse-item>

            </van-collapse>

            <div><span>安卓 <span style="color: #EB4D3D;">8.0及以下</span> 系统各类机型的设置说明：</span></div>
            <van-collapse v-model="activeName" accordion>

              <van-collapse-item title="(1)、华为荣耀手机设置说明" name="华为荣耀手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/11.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(2)、华为mate手机设置说明" name="华为mate手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/22.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(3)、OPPO手机设置说明" name="OPPO手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/33.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(4)、vivo手机设置说明" name="vivo手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/44.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(5)、小米手机设置说明" name="小米手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/55.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(6)、红米手机设置说明" name="红米手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/66.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(7)、麦芒手机设置说明" name="麦芒手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/77.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(8)、三星6.0及以上手机设置说明" name="三星6.0及以上手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/88.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(9)、三星5.0系统手机设置说明" name="三星5.0系统手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/99.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(10)、三星4.0系统手机设置说明" name="三星4.0系统手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/1010.png" alt="">
                </div>
              </van-collapse-item>

              <van-collapse-item title="(11)、锤子手机设置说明" name="锤子手机设置说明">
                <div>
                  <img style="width: 100%;" src="@/img/notice/1111.png" alt="">
                </div>
              </van-collapse-item>

            </van-collapse>

          </div>

          <div class="pcMenu1Two" v-show="gytzIndex==1">
            <div><span @click="gytzIndex=-1">消息提醒></span><span style="color: #333333;">海鸥通知设置</span></div>
            <div>
              <p>在【我的-设置中心-消息通知】进入通知设置页面，对海鸥消息进行设置。<br><br>

                海鸥打开/未开打的通知设置<br>
                在【海鸥未打开】的状态下，选择是否开启消息通知提醒；在【海鸥打开】的状态下，消息是默认没有铃声提醒的，这时候可以选择接收到消息是否伴有震动提醒。<br><br>

                安卓端手机设置内开启后台运行<br>
                在【海鸥未打开】的状态下，选择是否开启消息通知提醒；在【海鸥打开】的状态下，消息是默认没有铃声提醒的，这时候可以选择接收到消息是否伴有震动提醒。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gytzIndex==2">
            <div><span @click="gytzIndex=-1">消息提醒></span><span style="color: #333333;">手机消息提醒说明</span></div>
            <div>
              <p>苹果手机消息提醒设置<br>
                通过手机中的【设置-通知】找到【海鸥】，开启【允许通知】。<br><br>

                华为手机消息提醒设置<br>
                通过手机中的【设置-通知中心】找到【海鸥】，开启【允许通知】，在下面的类别中设置通知形式。<br><br>

                小米手机消息提醒设置<br>
                通过手机中的【设置-通知与控制中心-通知管理】找到【海鸥】开启通知权限，点击进入详情页设置通知形式。<br><br>

                vivo手机消息提醒设置<br>
                通过手机中的【设置-状态栏与通知-通知管理】在应用列表找到【海鸥】开启【允许通知】并设置通知形式。<br><br>

                OPPO手机消息提醒设置<br>
                通过手机中的【设置-通知与状态栏】在应用列表找到【海鸥】开启【允许通知】并设置通知形式。<br><br>

                乐视手机消息提醒设置<br>
                通过手机中的【设置-通知管理】为【海鸥】开启通知权限，点击进入详情页设置通知形式。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gytzIndex==3">
            <div><span @click="gytzIndex=-1">消息提醒></span><span style="color: #333333;">苹果手机消息设置</span></div>
            <div>
              <img style="width: 100%;" src="@/img/notice/pg.png" alt="">
            </div>
          </div>

        </div>

        <div class="pc-menu1-6" v-show="pcMenu1Index==6">

          <div class="pcMenu1One" v-show="gyscIndex==-1">
            <div><span>关于商城</span></div>
            <div>
              <p @click="gyscIndex=1">1. 卡券专区</p>
              <p @click="gyscIndex=2">2. 会员专区</p>
              <p @click="gyscIndex=3">3. 靓号专区</p>
              <p @click="gyscIndex=4">4. 鸥币专区</p>
              <p @click="gyscIndex=5">5. 其他专区</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==1">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">卡券专区</span></div>
            <div>
              <p>通过【我的-海鸥商城】进入海鸥商城界面，在【我的卡券】板块中可以查看自己拥有的所有卡券。<br><br>

                靓号券<br>
                可兑换当前的ID号，兑换后原ID将会被回收，可在【靓号专区-靓号广场】购买心仪的ID号。<br><br>

                经验券<br>
                经验券用于兑换经验值，可通过鸥币抽奖或商城购买经验券获得，也可通过别人赠送获得。<br><br>

                靓号服务券<br>
                靓号服务券用于兑换靓号服务，使用之后可获得靓号标识，1.3倍加速，昵称高亮显示。可在【靓号专区-靓号服务】购买获得。<br><br>

                会员券<br>
                会员券用于兑换等价值的会员，使用会员券后有相应铭牌显示、昵称高亮、1.3倍加速、隐藏ID号等功能。<br><br>

                群靓号券<br>
                可兑换当前群的ID号，兑换后原ID将会被回收，可在【靓号专区-群靓号广场】购买心仪的群ID号。<br><br>

                群靓号服务券<br>
                群靓号服务券用于兑换群靓号服务，使用之后可获得靓号标识，群昵称高亮显示。可在【靓号专区-群靓号服务】购买获得。<br><br>

                折扣券<br>
                折扣券用于购买海鸥商城的会员券、靓号服务券、靓号券等使用。可在【海鸥商城-鸥币抽奖】抽奖获得。<br><br>

                产品券<br>
                海鸥不定时出相应的活动。可在【海鸥商城-积分抽奖】抽奖获得。<br><br>

                唯名卡券<br>
                唯名卡修改唯一昵称仅支持当前1次操作，修改昵称提交成功后，再次修改昵称，唯名卡失效。可通过【海鸥商城-唯名卡-唯名卡购买】获得。<br><br>

                群管家券<br>
                使用群管家券后需要群主/管理员手动去该群【群聊设置】打开群管家开关，并设置相关管理权限。可通过【靓号专区-购买群管家】获得。<br><br>

                个人曝光卡<br>
                使用个人曝光卡后将获得相应人次曝光特权，如使用100人次曝光卡将会像100个可能感兴趣的用户推荐你的个人名片，增加你的曝光度。可通过【排行榜-日榜】排名第一获得。<br><br>

                群活跃点券<br>
                群活跃点券使用后可增加群的活跃点，活跃点越高群排名越靠前。可通过【海鸥商城-购买群活跃点券】获得。<br><br>

                群容量升级卡<br>
                群容量升级卡使用后不占有群主会员等级原有的超级群数量，群当前容量低于将要升级的容量方能使用群容量升级卡。可通过【海鸥商城-购买群容量升级卡】获得。<br><br>

                等级卡<br>
                使用等级卡后，可将当前账号等级直接升级为使用的相应等级卡等级，非SVIP用户不可使用等级卡，使用等级账号等级必须在对应等级范围方可使用。可通过【海鸥商城-购买等级卡】获得。<br><br>

                换绑卡<br>
                使用换绑卡后，无需查收原账号绑定的手机验证码即可立即换成新的手机号。可通过【海鸥商城-鸥币抽奖】获得。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==2">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">会员专区</span></div>
            <div>
              <p>通过【我的-海鸥商城】进入海鸥商城界面，在【会员专区】板块中可以开通会员、购买会员券、合成SVIP和购买等级卡。<br><br>

                开通会员<br>
                通过【海鸥商城-会员专区】进入会员中心，选择开通时间，点击【立即开通】，支付对应金额进行开通。<br><br>

                购买会员券<br>
                通过【海鸥商城-购买会员券】进入购买会员券，选择开通时间，点击【立即支付】后选择购买数量，支付对应金额。<br><br>

                靓号服务券<br>
                靓号服务券用于兑换靓号服务，使用之后可获得靓号标识，1.3倍加速，昵称高亮显示。可在【靓号专区-靓号服务】购买获得。<br><br>

                合成SVIP<br>
                通过【海鸥商城-合成SVIP】进入合成页面，需12张VIP券合成1张SVIP券<br><br>

                购买等级卡<br>
                可通过【海鸥商城-购买等级卡】获得。使用等级卡后，可将当前账号等级直接升级为使用的相应等级卡等级，非SVIP用户不可使用等级卡，使用等级账号等级必须在对应等级范围方可使用。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==3">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">靓号专区</span></div>
            <div>
              <p>靓号服务<br>
                开通靓号服务，可以点亮靓号身份铭牌、昵称高亮显示、获得1.3倍的经验成长值。在购买靓号时，会自动赠送一定时间的靓号服务。<br><br>

                靓号广场<br>
                如果要更换当前的ID号，可通过【我的-海鸥商城-靓号专区-靓号广场】进入购买，可直接购买替换当前ID，也可以购买靓号券。<br><br>

                群靓号<br>
                如果要更换某个群的ID号，可通过【我的-海鸥商城-靓号专区-群靓号】进入购买，可直接购买替换当前某个群的ID，也可以购买靓号券。<br><br>

                群靓号服务<br>
                通过【海鸥商城-靓号专区-群靓号服务】获得。使用后可点亮群身份铭牌，群昵称高亮，截屏通知。<br><br>

                购买群管家券<br>
                通过【海鸥商城-靓号专区-购买群管家券】购买获得。群管家有进群欢迎语、发言管理、自助问答、刷频检测、定时消息、群黑名单管理功能。<br><br>

                群容量升级<br>
                通过【海鸥商城-购买群容量升级卡】购买获得。群容量升级卡使用后不占有群主会员等级原有的超级群数量，群当前容量低于将要升级的容量方能使用群容量升级卡。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==4">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">鸥币专区</span></div>
            <div>
              <p>我的鸥币<br>
                在鸥币专区，点击【我的鸥币】进入鸥币详情页，在该页面可以查看你当前的积分，以及收入/支出的详细情况<br><br>

                鸥币充值<br>
                在鸥币专区，点击【我的鸥币】进入鸥币充值页面，选择需要充值的鸥币数量再点击【立即充值】即可；点击右上角的【鸥币明细】可查看鸥币的收入/支出明细。<br><br>

                鸥币抽奖<br>
                在【鸥币抽奖】，可以消耗鸥币来抽取奖品，奖品以实际转盘为准，不定时更新奖品。<br><br>

                个性装扮<br>
                在【个性装扮】中，会员可选择对应的气泡、头像框、进群特效、贵族专享头像。<br><br>

                积分抽奖<br>
                在【积分抽奖】，可以消耗积分来抽取奖品，奖品以实际转盘为准，不定时更新奖品。积分来源：不定时邀请好友可获得积分。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyscIndex==5">
            <div><span @click="gyscIndex=-1">关于商城></span><span style="color: #333333;">其他专区</span></div>
            <div>
              <p>购买经验券<br>
                在其他专区，点击【购买经验券】进入购买页面，选择需要购买的经验券值，可以选择购买数量。<br><br>

                购买群活跃点<br>
                在其他专区，点击【购买群活跃点】进入购买页面，选择需要购买的经验券值，可以选择购买数量。<br><br>

                签到中心<br>
                在【签到中心】，每日签到可获得经验值，每日做任务也可获得经验值、会员、靓号服务。<br><br>

                卡券兑换<br>
                在【卡券兑换】中，30天靓号服务券、9折折扣券、8折折扣券、7折折扣券可兑换相应的鸥币。
              </p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-7" v-show="pcMenu1Index==7">
          <div class="pcMenu1One" v-show="yjqlIndex==-1">
            <div><span>一键清理</span></div>
            <div>
              <p @click="yjqlIndex=1">1. 一键清空聊天（单向)</p>
              <p @click="yjqlIndex=2">2. 一键已读消息</p>
              <p @click="yjqlIndex=3">3. 一键好友免打扰</p>
              <p @click="yjqlIndex=4">4. 一键删除好友</p>
              <p @click="yjqlIndex=5">5. 一键退出群聊</p>

              <p @click="yjqlIndex=6">6. 一键解散群聊（群主)</p>
              <p @click="yjqlIndex=7">7. 一键群聊免打扰</p>
              <p @click="yjqlIndex=8">8. 一键收进群助手</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==1">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键清空聊天（单向）</span></div>
            <div>
              <p>一键清空聊天<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【清空所有聊天】。<br>
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==2">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键已读消息</span></div>
            <div>
              <p>一键全部已读<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【全部标记已读】。<br>
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==3">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键好友免打扰</span></div>
            <div>
              <p>一键全部免打扰<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有好友】选择指定的好友后点击【一键免打扰】
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==4">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键删除好友</span></div>
            <div>
              <p>一键删除好友<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有好友】选择指定的好友后点击【删除好友】
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==5">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键退出群聊</span></div>
            <div>
              <p>一键退出群聊<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有群聊-我加入的群聊】选择想要退出的群聊，点击底部【一键退群】按钮即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==6">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键解散群聊（群主）</span></div>
            <div>
              <p>一键退出群聊<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有群聊-我创建的群聊】选择想要解散的群聊，点击底部【一键解散群】按钮即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==7">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键群聊免打扰</span></div>
            <div>
              <p>一键群聊免打扰<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有群聊-我加入的群聊/我创建的群聊】选择想要免打扰的群聊，点击底部【一键免打扰】按钮即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="yjqlIndex==8">
            <div><span @click="yjqlIndex=-1">一键清理></span><span style="color: #333333;">一键收进群助手</span></div>
            <div>
              <p>一键收进群助手<br>
                在【消息】界面中，长按某条消息，在出现的操作栏点击【管理聊天列表】，再点击【管理所有群聊-我加入的群聊/我创建的群聊】选择想要收进群助手的群聊，点击底部【收进群助手】按钮即可。
              </p>
            </div>
          </div>

        </div>

        <div class="pc-menu1-8" v-show="pcMenu1Index==8">
          <div class="pcMenu1One" v-show="gyqtIndex==-1">
            <div><span>关于其他</span></div>
            <div>
              <p @click="gyqtIndex=1">1. 邀请福利</p>
              <p @click="gyqtIndex=2">2. 排行榜</p>
              <p @click="gyqtIndex=3">3. 问题反馈</p>

            </div>

          </div>

          <div class="pcMenu1Two" v-show="gyqtIndex==1">
            <div><span @click="gyqtIndex=-1">关于其他></span><span style="color: #333333;">邀请福利</span></div>
            <div>
              <p>邀请福利<br>
                在【发现-福利中心】界面中，点击【邀请好友领奖励】，再点击【邀请好友】，将自己的二维码名片分享出去，邀请好友注册使用海鸥APP，就可以获取相应的奖励。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqtIndex==2">
            <div><span @click="gyqtIndex=-1">关于其他></span><span style="color: #333333;">排行榜</span></div>
            <div>
              <p>查看排行榜<br>
                在【发现-等级排行】进入海鸥全球排行榜。排行榜分为日榜、周榜、总榜，每个榜单都是根据对应时间内获得的经验值进行排名的。例如：日榜是按照当日账号获得的经验值由大小从上至下排名。<br><br>

                参与排行榜排名<br>
                在【发现-等级排行】进入海鸥全球排行榜。需要经验值排在前100名，个人信息里不能包含违规违法信息即可参与。若不想参与排名点击右上角的【...】，选择【不参与排名】即可。
              </p>
            </div>
          </div>

          <div class="pcMenu1Two" v-show="gyqtIndex==3">
            <div><span @click="gyqtIndex=-1">关于其他></span><span style="color: #333333;">问题反馈</span></div>
            <div>
              <p>问题反馈<br>
                在【我的-海鸥助手-意见反馈】填写你要反馈的问题后提交。也可以直接联系在线客服进行反馈问题。反馈问题不定时有奖励哦。
              </p>
            </div>
          </div>

        </div>

      </div>

      <div class="pc-menu2" v-show="menuIndex==2">
        <h1 style="text-align: center;">用户协议</h1>
        <div v-html="agreementMember" style="text-align: left;
    margin-left: 16px;
    margin-right: 16px;word-wrap: break-word; /* 允许在长单词内部换行 */
  word-break: break-all; /* 允许在任意位置换行 */">

        </div>
      </div>

      <div class="pc-menu3" v-show="menuIndex==3">
        <h1 style="text-align: center;">隐私政策</h1>
        <div v-html="agreementPrivacy" style="text-align: left;
    margin-left: 16px;
    margin-right: 16px;word-wrap: break-word; /* 允许在长单词内部换行 */
  word-break: break-all; /* 允许在任意位置换行 */">

        </div>
      </div>

      <div class="pc-menu4" v-show="menuIndex==4">
        <h1 style="text-align: center;">会员协议</h1>
        <div v-html="vipAgreement" style="text-align: left;
    margin-left: 16px;
    margin-right: 16px;word-wrap: break-word; /* 允许在长单词内部换行 */
  word-break: break-all; /* 允许在任意位置换行 */">

        </div>
      </div>

    </div>

    <bottom></bottom>
    <down></down>
  </div>

</template>

<script>
import api from "@/api/api";
import request from '@/api/request';
import headr from '@/components/head/index'
import bottom from '@/components/bottom/index'
import down from '@/components/down/index'
import {
  Notify
} from 'vant';
import {
  Dialog
} from 'vant';
export default {
  components: {
    headr,
    bottom,
    down
  },
  data() {
    return {
      menuIndex: 0,
      menuYes: 'border-bottom: 4px solid #4371FF;color: #4371FF;height: 26px;',
      menuNo: 'border-bottom: 0px;color: #666666;height: 26px;',

      pcMenu1Index: 0,
      pcMenu1Yes: 'background: #E6ECFF;;color: #4371FF;',
      pcMenu1YesNo: 'color: #666666;',

      pcMenu10: -1,
      gyzhIndex: -1,
      gyhyIndex: -1,
      gyqlIndex: -1,
      gyltIndex: -1,
      gytzIndex: -1,
      gyscIndex: -1,
      yjqlIndex: -1,
      gyqtIndex: -1,
      agreementPrivacy: '',
      agreementMember: '',
      vipAgreement: '',

      mobileMenu1Yes: 'color: #4371FF;',
      mobileMenu1YesNo: 'color: #666666;',


      activeName: '怎么添加好友？',

    }
  },
  created() {

  },
  computed: {

  },
  mounted() {


  },

  destroyed() {

  },
  methods: {
    gethtml(dictType, code, key) {
      var that = this;
      request.getWay(
        'sys/toHtml', {
        dictType: dictType,
        code: code
      },
        function (response) {
          console.log(response)
          if (key == 2) {
            that.agreementMember = response
          }
          if (key == 3) {
            that.agreementPrivacy = response
          }
          if (key == 4) {
            that.vipAgreement = response
          }
        }
      );





    },
    onclickPcMenu1(key) {

      this.pcMenu1Index = key

      // if (key == "menu1")
      //   this.$router.push({
      //     name: 'index'
      //   });
      // if (key == "menu2")
      //   this.$router.push({
      //     name: 'security'
      //   });
      // if (key == "menu3")
      //   this.$router.push({
      //     name: 'index'
      //   });



    },


    onclick(key) {

      this.menuIndex = key

      if (key == 2) {
        if (this.agreementMember == '' || this.agreementMember == undefined)
          this.gethtml("agreement", "agreementMember", key)
      }
      if (key == 3) {
        if (this.agreementPrivacy == '' || this.agreementPrivacy == undefined)
          this.gethtml("agreement", "agreementPrivacy", key)
      }
      if (key == 4) {
        if (this.vipAgreement == '' || this.vipAgreement == undefined)
          this.gethtml("agreement", "vipAgreement", key)
      }


    },

  }
}

</script>

//pc端
<style scoped>
/* 当屏幕宽度大于或等于768像素时，改为浮动布局 */
@media (min-width: 768px) {
  #mobile {
    display: none;
  }

  #pc {
  }

  .menu {
    display: flex;
    flex-flow: row;
    align-items: center;
    margin-top: 80px;
    margin-bottom: 52px;
    margin-right: 168px;
    margin-left: 168px;
  }

  .menu > div {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 18px;
    color: #666666;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-right: 80px;
  }

  .pc-menu0 {
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    align-items: center;

    margin-bottom: 137px;
    margin-right: 152px;
    margin-left: 152px;
  }

  .pc-menu0 > div {
    width: 303px;
    height: 384px;
    background: #fafafa;

    /* margin-right: 16px; */
    margin-left: 16px;
    margin-bottom: 32px;
    padding-top: 20px;
    padding-right: 32px;
    padding-left: 32px;
  }

  .pc-menu0 > div > p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    margin-top: 0;
    margin-bottom: 12px;
  }

  .pc-menu1 {
    display: flex;
    flex-flow: row;
    margin-right: 168px;
    margin-left: 168px;
  }

  .pc-menu1 > div:first-child {
    width: 230px;
    height: 504px;
    background: #fafafa;
    border-radius: 8px 8px 8px 8px;
    margin-right: 12px;
    margin-bottom: 81px;
  }

  .pc-menu1 > div:first-child > div {
    display: flex;
    flex-flow: row;
    align-items: center;
    width: 230px;
    height: 56px;
  }

  .pc-menu1 > div:first-child >>> img {
    width: 28px;
    height: 28px;
    margin-left: 20px;
    margin-right: 12px;
  }

  .pc-menu1 > div:first-child >>> p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .pc-menu1-0,
  .pc-menu1-1,
  .pc-menu1-2,
  .pc-menu1-3,
  .pc-menu1-4,
  .pc-menu1-5,
  .pc-menu1-6,
  .pc-menu1-7,
  .pc-menu1-8 {
    width: 1342px;
    background: #fafafa;
    border-radius: 8px 8px 8px 8px;
    margin-bottom: 49px;
    padding-top: 32px;
    padding-left: 32px;
    padding-right: 32px;
    padding-bottom: 15px;
  }

  .pcMenu1One > div:first-child {
    text-align: left;
  }

  .pcMenu1One > div:first-child > span {
    margin-top: 0;
    margin-bottom: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #4371ff;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .pcMenu1One > div:last-child > p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 24px;
    margin-bottom: 0;
  }

  .pcMenu1Two > div:first-child {
    text-align: left;
  }

  .pcMenu1Two > div:first-child > span {
    margin-top: 0;
    margin-bottom: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #4371ff;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .pcMenu1Two > div:last-child > p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 25px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
</style>

//移动端
<style scoped>
/* 当屏幕宽度小于或等于768像素时，应用以下样式 */
@media (max-width: 768px) {
  #pc {
    display: none;
  }

  .menu {
    display: flex;
    flex-flow: row;
    flex-wrap: nowrap;
    align-items: center;
    margin-top: 65px;
    margin-bottom: 32px;
    margin-left: 16px;
    overflow-x: auto;
    white-space: nowrap;
  }

  .menu::-webkit-scrollbar {
    display: none;
  }

  .menu > div {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-right: 32px;
  }

  .pc-menu0 {
    text-align: left;
    margin-bottom: 30px;
  }

  .pc-menu1 {
    display: flex;
    flex-flow: column;
    margin-right: 16px;
    margin-left: 16px;
  }

  .pc-menu1 > div:first-child {
    width: 100%;
    background: #ffffff;
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .pc-menu1 > div:first-child > div {
    height: 65px;
    margin-right: 18px;
    display: flex;
    flex-flow: column;
    align-items: center;
  }

  .pc-menu1 > div:first-child > div > img {
    width: 40px;
    height: 40px;
  }

  .pc-menu1-0,
  .pc-menu1-1,
  .pc-menu1-2,
  .pc-menu1-3,
  .pc-menu1-4,
  .pc-menu1-5,
  .pc-menu1-6,
  .pc-menu1-7,
  .pc-menu1-8 {
    margin-top: 15px;
    margin-bottom: 30px;
    padding-top: 15px;

    padding-bottom: 15px;
  }

  .pc-menu1-5 > div:nth-child(1) > div:nth-child(2) > p:nth-child(1) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 0;
  }
  .pc-menu1-5 > div:nth-child(1) > div:nth-child(2) > p:nth-child(2) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 8px;
    margin-bottom: 0;
  }
  .pc-menu1-5 > div:nth-child(1) > div:nth-child(2) > p:nth-child(3) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 4px;
    margin-bottom: 0;
  }
  .pc-menu1-5 > div:nth-child(1) > div:nth-child(2) > p:nth-child(4) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #eb4d3d;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 4px;
    margin-bottom: 0;
  }
  .pc-menu1-5 > div:nth-child(1) > div:nth-child(2) > p:nth-child(5) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 0;
  }
  .pc-menu1-5 > div:nth-child(1) > div:nth-child(2) > p:nth-child(6) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 0;
  }
  .pc-menu1-5 > div:nth-child(1) > div:nth-child(2) > p:nth-child(7) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 0;
  }

  .pc-menu1-5 > div:nth-child(1) > div:nth-child(3) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 5px;
  }

  .pc-menu1-5 > div:nth-child(1) > div:nth-child(5) {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 16px;
    margin-bottom: 5px;
  }
  .pcMenu1One > div:first-child {
    text-align: left;
  }

  .pcMenu1One > div:first-child > span {
    margin-top: 0;
    margin-bottom: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #4371ff;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .pcMenu1One > div:last-child > p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 24px;
    margin-bottom: 0;
  }

  .pcMenu1Two > div:first-child {
    text-align: left;
  }

  .pcMenu1Two > div:first-child > span {
    margin-top: 0;
    margin-bottom: 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #4371ff;
    line-height: 21px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .pcMenu1Two > div:last-child > p {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
    line-height: 25px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }

  .pcMenu1One >>> .van-cell {
    padding-left: 0px;
    padding-right: 0px;
  }

  .pcMenu1One >>> .van-collapse-item__content {
    padding-left: 0px;
    padding-right: 0px;
  }
  .pcMenu1One >>> .van-cell__title {
    color: #4371ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/helpCenter/index.vue